// validation/subscrition

import { Component, ElementRef, Renderer2, ViewChild, HostListener } from '@angular/core';
import { CustomDatePipe } from '../pipes/custom-date.pipe';
import { DecimalPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { api } from '../URL/api-url';
import { parseDateOnly, toApiDate, toLegacyUsDate } from '../CommonFunctions/date-utils';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-upgrade-plans',
  templateUrl: './upgrade-plans.component.html',
  styleUrls: ['./upgrade-plans.component.css'],
  providers: [DecimalPipe, CustomDatePipe],
})
export class UpgradePlansComponent {
  lifePlans: any = [];currClient: any = '';
;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private _CustomDatePipe: CustomDatePipe,
    private _decimalPipe: DecimalPipe,
    private http: HttpClient,
    private router: Router,
    private formBuilder: FormBuilder, private route: ActivatedRoute,
  ) {
    this.lang = sessionStorage.getItem("language");
  }

  public formData: any;
  public allFormData: any = {};
  public lastUpdatedType: any = "";
  public signUpData: any = {};
  public premiums: any = {};
  names: any;
  greenValue: any;
  yellowValue: any;
  activeValuePosition: any;
  productobj: any;
  minValue = 0;
  greenWidth: any;
  orangeWidth: any;
  filledWidth: any;
  cutoffWidth: any;
  rangeValues: any;
  minimumCoverage: any;
  extraCoverage: any;
  plansData: any;
  showyellowbar: boolean =false;
  planssummarymainLife: any;
  planssummaryopt: any;
  public plansskumain: any = [];
  plansnexttab: any;
  cartcheckvalue: any;
  planssummarymain: any;
  planAmount: any;
  memberDateofBirth: any = true;
  displaySideBar = true;
  groupKeys: any;
  width = "265px";
  details: any;
  plansummaryLIFE: any;
  plansummaryLIFEFinal: any=[];
  iafgPlansAvailability: any;
  plansummary: any=[];
  provisioning: any;
  configprovinceres: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  postalvalue: any;
  
  lifeMember: boolean = true;
  lifeSpouse: boolean = true;
  criticalMember: boolean = true;
  criticalSpouse: boolean = true;
  hasSpouse: boolean = false;
  hasMember: boolean = false;

  userForm = new FormGroup(
    {
      planEnrollmentDate: new FormControl(''),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      email: new FormControl(''),
      phone_number: new FormControl(''),
      street_address_line1: new FormControl(''),
      street_address_line2: new FormControl(''),
      apt: new FormControl(''),
      city: new FormControl(''),
      province: new FormControl(''),
      postal_code: new FormControl(''),
      date_of_birth: new FormControl(''),
      gender: new FormControl(''),
      date_of_hiring: new FormControl(''),
      company_name: new FormControl(''),
      job_title: new FormControl(''),
      placeOfBirth: new FormControl(''),
      occupation: new FormControl(''),
      working_20hours: new FormControl(''),
      hours_per_week: new FormControl(''),
      provincial_health_coverage: new FormControl(''),
      dateOfArrival: new FormControl(''),
      isEmployeeImigrant: new FormControl(''),
      applylandedstaus: new FormControl(''),
      countryOrigin: new FormControl(''),
      coverageRequiredOfEmployee: new FormControl(''),
      dependentdateOfArrival: new FormControl(''),
      coverageRequiredOfDependents: new FormControl(''),
      dependentcountryOrigin: new FormControl(''),
      dependentLandedImigrant: new FormControl(''),
      dependentapplylandedstaus: new FormControl(''),
      dependentMorethan3years: new FormControl(''),
      having_spouse: new FormControl(''),
      spousefirstname: new FormControl(''),
      spouselastname: new FormControl(''),
      spousegender: new FormControl(''),
      spouseOccupation: new FormControl(''),
      spousePlaceOfBirth: new FormControl(''),
      spousedateofbirth: new FormControl(''),
      spousehealthcard: new FormControl(''),
      Spousenameofthecarrier: new FormControl(''),
      spousecob: new FormControl(''),

      having_dependent_children: new FormControl(''),
      no_of_children: new FormControl(''),

      termsandconditions: new FormControl(''),
      disclouseradvisor: new FormControl(''),
      recaptchaReactivePerInfo: new FormControl(''),
    },
    { updateOn: 'change' }
  );

  addAditionalData: Array<any> = [];
  addAditionalData1: Array<any> = [];
  isEditable = true;
  enableEditIndex = null;
  @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  memberHeightUnit: string = 'cm';
  memberweightUnit: string = 'lbs';
  spouseHeightUnit: string = 'cm';
  spouseWeightUnit: string = 'lbs';
  familyForm: any;
  familyMembers: any;
  isAtleastOneMember: any;
  isAtleastOneSpouse: any;
  isFamilyMember: any;
  isFamilySpouse: any;
  physicianForm: any;
  physicianForm1: any;
  invalidpostalcodeprivince: boolean = false;
  invalidpostalcodeprivince1: boolean = false;
  additionalDetailsFormVisible = false;
  additionalDetailsFormVisible1 = false;
  insuranceForm: any;
  isSpouse: any = false;
  beneficiaries: any = [];
  spouseEdit: boolean = false;
  provinceList: any = ['ON', 'AB', 'BC'];
  memberInsurance: any = {
    lifeInsurance: false,
    lifeInsuranceCoverage: '',
    criticalIllness: false,
    criticalIllnessCoverage: ''
  }
  spouseInsurance: any = {
    lifeInsurance: false,
    lifeInsuranceCoverage: '',
    criticalIllness: false,
    criticalIllnessCoverage: ''
  }
  province: any;
  lang: any;
  selectedLanguage:any;
  questions: any = [
    { key: '3', label: 'In the last 12 months, have you used, in any form whatsoever, tobacco, nicotine or cannabis mixed with tobacco?' },
    { key: '4', label: 'Have you flown as a pilot, student or crew member in the last two years or do you have any intention to do so?' },
    { key: '5', label: 'Have you engaged in or do you intend to participate in scuba diving, parachuting or other hazardous sport or activity?' },
    { key: '6', label: 'Do you intend to travel or reside outside Canada or the United States for more than a month?' },
    { key: '7', label: 'Have you had a request for life, disability or critical illness insurance declined, postponed, rated or modified in any way?' },
    { key: '8', label: 'Are you now actively engaged in your occupation on a full-time basis? If “No”, please provide details including reason why you are not working on a full-time basis.' },
    { key: '9', label: 'Have you ever had or ever been treated for cancer, tumour, cyst, polyp or other growth, moles, anemia, blood disorder or any form of malignant disease?' },
    { key: '10', label: 'Have you ever had or have you ever been treated for chest pain, angina, heart attack, high blood pressure, abnormal ECG, stroke, paralysis, transient ischemic attack (TIA), elevated cholesterol, or other disorders of the heart or aorta, blood vessels or circulatory system? Diabetes, pancreatitis,thyroid or other endocrine disorder? Lung or other respiratory disease or disorder? Any disorder of the eyes (excluding near or far sightedness), ears,vocal chords or larynx including loss of speech?' },
    { key: '11', label: 'Have you ever been treated for or diagnosed with kidney, bladder, prostate (including an elevated PSA test result) or breast disorder (including cysts,lumps, biopsy or abnormal mammogram or ultrasound) or other genitourinary disorder, hepatitis B or C (including carrier), cirrhosis or other liver disorder, ulcerative colitis, Crohn’s disease or other disorder of the gastrointestinal tract?' },
    { key: '12', label: 'Have you ever had or have you ever been treated for dizziness, seizures, epilepsy, tremor, paresthesia, loss of balance, numbness, multiple sclerosis,Alzheimer’s disease, Parkinson’s disease, amyotrophic lateral sclerosis (ALS) or any other neurological disorder? Stress, anxiety, depression or any other psychiatric disorder? Disease or disorder of muscles, ligaments, tendons, bones or joints including but not limited to arthritis, lupus in any form,amputation or deformity?' },
    { key: '13', label: 'Have you ever used marijuana, heroin, morphine, cocaine, LSD, barbiturates, amphetamines, or any other drug or narcotic, except as prescribed by your physician?' },
    { key: '14a', label: 'Do you presently drink more than 12 alcoholic beverages per week? If “Yes”, state number, kind and frequency consumed.' },
    { key: '14b', label: 'Have you ever changed your pattern of drinking (increased or decreased), received advice or treatment for, or attended any rehabilitation program for alcohol or drug use?' },
    { key: '15', label: 'Have you any condition for which hospitalization, further testing, investigation or surgery has been advised, or which have not yet been done, or for which you are still awaiting results?' },
    { key: '16', label: 'Are you taking any prescribed medication? If “Yes”, state name of medication and reason for use.' },
    { key: '17', label: 'Are you aware of any symptoms or complaints regarding your health for which you have not yet consulted a physician or received treatment?' },
    { key: '18', label: 'Have you been absent from work for more than seven consecutive days within the past year due to sickness or injury?' },
    { key: '19', label: 'Has there been a variation in your weight in the past year? If “Yes”, please provide details including reason and number of pounds/kilograms gained or lost.' },
    { key: '20', label: 'Females only: Are you currently pregnant? If “Yes”, please provide your estimated due date and advise of any complications with current or past pregnancies.' },
    { key: '21', label: 'During the past 10 years, have you consulted a physician, received treatment or been hospitalized, had surgery or any test (other than routine checkup or minor injury) for any disease, disorder or ailment not already mentioned?' },
    { key: '22', label: 'Have you ever received or claimed benefits or a pension for sickness, injury or impairment?' },
    { key: '23', label: 'Do you have any pending criminal offences, criminal convictions, had your driver’s license suspended, or within the past 3 years been convicted of more than 3 traffic violations?' }
  ];

  additionalDetailsform: FormGroup = new FormGroup({
    questionNumber: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    additionalDetails: new FormControl('', [Validators.required]),
  });

  additionalDetailsTable = false;
  additionalDetailsForm = true;
  additionalDetailsTable1 = false;
  additionalDetailsForm1 = true;
  isAvailableCache: { [key: string]: boolean } = {};
  spouseDataCache: { [key: string]: boolean } = {};
  spouseCache: { [key: string]: boolean } = {};

  familyData = [
    { label: 'Father', key: 'father' },
    { label: 'Mother', key: 'mother' },
    { label: 'Brothers', key: 'brothers' },
    { label: 'Sisters', key: 'sisters' }
  ];

  familyMember = {
    father: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    mother: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    brothers: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    sisters: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
  }

  familySpouse = {
    father: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    mother: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    brothers: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    sisters: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
  }
  customerid: any;
  accessToken: any;
  customerData: any;
  memberDetails: any = {};
  spouseDetails: any = {};
  plans: any;
  answers: any = [];
  answers1: any = [];
  having_spouse: boolean = false;
  formConfig: any;

  ngOnInit(): void {
    sessionStorage.setItem('plansummaryLife', '[]');
    sessionStorage.setItem('planssummarymainLife', '[]');
    let client = sessionStorage.getItem('currClient')
    if(client){
      this.currClient = client
    }

    this.having_spouse = sessionStorage.getItem('isSpouse') == 'true' ? true : false;
    this.getPlans()


    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.customerid = sessionStorage.getItem("customerId");
    this.accessToken = sessionStorage.getItem('accessToken');
    this.getCustomerData();
    this.getFormConfiguration('en');
    this.getLanguageTokens();
    setTimeout(() => {
    }, 10000);

    this.insuranceForm = this.formBuilder.group({
      memberHeight: ['', [Validators.required]],
      memberHeightUnit: [''],
      memberWeight: ['', [Validators.required]],
      memberWeightUnit: [''],
      spouseHeight: this.isSpouse ? ['', [Validators.required]] : [''],
      spouseHeightUnit: [''],
      spouseWeight: this.isSpouse ? ['', [Validators.required]] : [''],
      spouseWeightUnit: [''],
      ...this.questions.reduce((acc: any, _: any, index: number) => {
        acc[`memberQuestion${index + 1}`] = ['', [Validators.required]],
          acc[`spouseQuestion${index + 1}`] = [''];
        return acc;
      }, {})
    });

    this.familyMembers = [
      { name: 'Father', formControlNamePrefix: 'father' },
      { name: 'Mother', formControlNamePrefix: 'mother' },
      { name: 'Brothers', formControlNamePrefix: 'brothers' },
      { name: 'Sisters', formControlNamePrefix: 'sisters' }
    ];

    this.familyForm = this.formBuilder.group({
      memberHasConditions: ['', [Validators.required]],
      spouseHasConditions: this.isSpouse && this.isSpouse == true ? ['', [Validators.required]] : ['']
    });

    this.physicianForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, this.phoneNumberValidator()]],
      streetAddress: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      dateLastConsulted: ['', [Validators.required]],
      consultationReason: ['', [Validators.required]],
      consultationResult: ['', [Validators.required]]
    });
    this.physicianForm1 = this.formBuilder.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, this.phoneNumberValidator()]],
      streetAddress: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      dateLastConsulted: ['', [Validators.required]],
      consultationReason: ['', [Validators.required]],
      consultationResult: ['', [Validators.required]]
    });

    this.physicianForm.get('number').valueChanges.subscribe(value => {
      const formattedValue = this.formatPhoneNumber(value);
      if (formattedValue != this.physicianForm.get('number').value) {
        this.physicianForm.get('number').setValue(formattedValue, { emitEvent: false });
      }
    });
    this.physicianForm1.get('number').valueChanges.subscribe(value => {
      const formattedValue = this.formatPhoneNumber(value);
      if (formattedValue != this.physicianForm1.get('number').value) {
        this.physicianForm1.get('number').setValue(formattedValue, { emitEvent: false });
      }
    });

    this.additionalDetailsform = this.formBuilder.group({
      questionNumber: ['', [Validators.required]],
      value: ['', [Validators.required]],
      additionalDetails: ['', [Validators.required]],
    })
  }

  getPlans() {
    const customerId = sessionStorage.getItem('customerId');
    const accessToken = sessionStorage.getItem('accessToken');
    var endPoint = `/customer/${customerId}/iafg/plans`
    this.http.post(api.url + endPoint, {}, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        const responseData = response?.data;
        console.log('responseData', responseData)
        if(responseData?.isCorporate != undefined && responseData.isCorporate == true){
          this.plansData = [{groups:{43:[]}}]
          this.plansData[0].groups[43] = responseData.blocks.paidByEmployee[0].groupsEP
          console.log('this.plansData', this.plansData)
          this.groupKeys = Object.keys(this.plansData[0].groups);
        }
        else if(responseData?.packages!=undefined){
          this.plansData = responseData?.packages
  
          for (let i = 0; i < this.plansData.length; i++) {
            console.log('package.name', this.plansData[i].groups)
            console.log('package.name', this.plansData[i].groups['43'])
            if (this.plansData[i] && this.plansData[i].groups) {
              this.groupKeys = Object.keys(this.plansData[i].groups);
            }
            for (let j = 0; j < this.plansData[i].groups['43'].length; j++) {
              console.log('this.plansData[i].groups', this.plansData[i].groups['43'][j].plans)
            }
          }
          console.log('this.plansData', this.plansData)
        }
        console.log('this.groupKeys', this.groupKeys)
      }
      else {
      }
      this.getSelectedPlanes()
    }, (error) => {
    });
  }

  questionnaireBtn() {
    console.log(this.allFormData);

    const memberIsSmoker = this.allFormData['LIFE']?.member?.isSmoker === 'yes' || this.allFormData['CRITICAL_ILLNESS']?.member?.isSmoker === 'yes';
    const spouseIsSmoker = this.allFormData['LIFE']?.spouse?.isSmoker === 'yes' || this.allFormData['CRITICAL_ILLNESS']?.spouse?.isSmoker === 'yes';

    if (!this.insuranceForm.value.memberQuestion) {
      this.insuranceForm.patchValue({memberQuestion1: memberIsSmoker ? 'yes' : 'no'});
    }

    if (!this.insuranceForm.value.spouseQuestion) {
      this.insuranceForm.patchValue({spouseQuestion1: spouseIsSmoker ? 'yes' : 'no'});
    }

    console.log(this.insuranceForm.value);
  }

  updateAddressForm() {
    this.physicianForm.markAllAsTouched();
    this.physicianForm1.markAllAsTouched();
    this.invalidpostalcodeprivince =false
    this.invalidpostalcodeprivince1 =false
  }

  public provincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });
    if (this.physicianForm.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.physicianForm.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.physicianForm.get('postalCode').markAsTouched();
        this.invalidpostalcodeprivince1 = true;
        this.physicianForm1.get('postalCode').markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
        this.invalidpostalcodeprivince1 = false;
      }
      if (this.physicianForm.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        this.invalidpostalcodeprivince1 = false;
      }
    }
  }

  changeTextToUppercase(event: any) {
    const inputValue = this.physicianForm.get('postalCode')?.value;
    this.physicianForm.get('postalCode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    this.postalvalue = event.target.value;
    if (this.provincialZipcodes?.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
      this.invalidpostalcodeprivince1 = true;
      this.physicianForm['postalCode'].markAsTouched();
      this.physicianForm1['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
      this.invalidpostalcodeprivince1 = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
      this.invalidpostalcodeprivince1 = false;
    }
  }

  getSelectedPlanes() {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerId = sessionStorage.getItem('customerId');
    let customerEndpoint = `/customer/v3/${customerId}/plans/false`;
    this.http.get(api.url + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'applivation/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {

        this.lifePlans = response.data.lifePlans


        if (this.lifePlans.length > 0) {
          this.lifePlans.sort((a, b) => {
            // Compare the names of the objects
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
        }

        this.lifePlans.forEach((element: any, index: number) => {

          let details: any = JSON.parse(element.additionalDetails)

          const dom: HTMLElement = this.elementRef.nativeElement;

          console.log(details)
          this.details = details
          console.log(Object.keys(details))

          let planCoverages: any = []

          if (Object.keys(details).includes('member')) {

            console.log(details)
            if (details.member.amount) {
              planCoverages.push({ "coverage": details.coverage, "class": "." + details.coverage + "-" + "member", "data": details.member })
            }
          }
          if (Object.keys(details).includes('spouse')) {

            console.log(details)
            if (details.spouse.amount) {
              planCoverages.push({ "coverage": details.coverage, "class": "." + details.coverage + "-" + "spouse", "data": details.spouse })
            }
          }
          planCoverages.forEach((finaldata: any, index: number) => {
            console.log(finaldata)
            console.log(finaldata.class)
            let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
            plansummaryLife.forEach((element: any, index: any) => {

              console.log(element.planCoverage)
              console.log(details.coverage)

              if (element.planCoverage == details.coverage) {
                plansummaryLife.splice(index, 1)
              }
            })
            let plan: any = ''
            setTimeout(() => {
              plan=dom.querySelector(finaldata.class);
            }, 0);

            setTimeout(() => {


              sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
              
              // Check if it's enabled and not already checked
              if (!plan.disabled && !plan.checked) {
                  plan.click(); // Click the checkbox
                  console.log('Checkbox clicked');
              } else {
                  console.log('Checkbox is either disabled or already checked');
              }

              let smokervalue = ''
              if (finaldata.data.smoker == true) {
                smokervalue = "yes"
              } else {
                smokervalue = "no"
              }

              if (finaldata.data.coverage == "MEMBER & SPOUSE") {
                finaldata.data.coverage = "SPOUSE"
              }
              const plan2: any = dom.querySelector("." + finaldata?.data?.coverage.toLowerCase() + "-" + finaldata.coverage + "-" + smokervalue);
              console.log(plan2)
              setTimeout(() => {
                plan2?.click()


                this.updateFormData(finaldata?.coverage, finaldata?.data?.coverage.toLowerCase(), {
                  isSmoker: smokervalue,
                  premium: this.updatePremium(finaldata?.coverage, finaldata?.data?.coverage.toLowerCase(), smokervalue),
                });


                this.allFormData[finaldata?.coverage][finaldata?.data?.coverage.toLowerCase()].coverage = finaldata?.data

                this.updateFormData(finaldata.coverage, finaldata?.data?.coverage.toLowerCase(), {
                  isSmoker: this.allFormData[finaldata.coverage][finaldata?.data?.coverage]?.isSmoker,
                  premium: this.updatePremium(finaldata.coverage, 
                    finaldata?.data?.coverage.toLowerCase(), 
                    this.allFormData[finaldata.coverage][finaldata?.data?.coverage.toLowerCase()].finaldata?.data?.smoker),
                });
              }, 100);
              
            }, 100);
          });

          setTimeout(() => {
          console.log('allFormData',this.allFormData)
        }, 1000);

        });
        console.log('allFormData',this.allFormData)
        this.plans = response.data.plans;
        // additional details for questionnaire
        for (let i = 0; i < this.plans?.length; i++) {
          let additionalDetails = JSON.parse(this.plans[i].additionalDetails) || []
          console.log({ additionalDetails })
          if ("Life Insurance".includes(additionalDetails?.name?.split('-')[0].trim())) {
            if (additionalDetails?.member && Object.keys(additionalDetails?.member)?.length > 0) {
              this.memberInsurance.lifeInsurance = true
              this.memberInsurance.lifeInsuranceCoverage = additionalDetails?.member?.coverageValue
              this.insuranceForm.patchValue({
                memberQuestion1: additionalDetails?.member?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                gender: additionalDetails?.member?.gender
              });
            }
            if (additionalDetails?.spouse && Object.keys(additionalDetails?.spouse)?.length > 0) {
              this.spouseInsurance.lifeInsurance = true
              this.spouseInsurance.lifeInsuranceCoverage = additionalDetails?.spouse?.coverageValue
              this.insuranceForm.patchValue({
                spouseQuestion1: additionalDetails?.spouse?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                spousegender: additionalDetails?.spouse?.gender
              });
              this.having_spouse = true;
            }
          }
          if ('Critical Illness Insurance'.includes(additionalDetails?.name?.split('-')[0].trim())) {
            if (additionalDetails?.member && Object.keys(additionalDetails.member)?.length > 0) {
              this.memberInsurance.criticalIllness = true
              this.memberInsurance.criticalIllnessCoverage = additionalDetails?.member?.coverageValue
              this.insuranceForm.patchValue({
                memberQuestion1: additionalDetails?.member?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                gender: additionalDetails?.member?.gender
              });
            }
            if (additionalDetails?.spouse && Object.keys(additionalDetails.spouse)?.length > 0) {
              this.spouseInsurance.criticalIllness = true
              this.spouseInsurance.criticalIllnessCoverage = additionalDetails?.spouse?.coverageValue
              this.insuranceForm.patchValue({
                spouseQuestion1: additionalDetails?.spouse?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                spousegender: additionalDetails?.spouse?.gender
              });
              this.having_spouse = true;
            }
          }
          for (let a = 0; a < this.plansData?.length; a++) {
            let plansData = this.plansData[a];
            for (let b = 0; b < plansData?.groups['43']?.length; b++) {
              let planGroups = plansData?.groups['43'][b];
              for(let c = 0; c < planGroups?.plans?.length; c++){
                let planGroupsPlan = planGroups.plans[c];
                console.log('planGroupsPlan', planGroupsPlan.productAddonss[planGroupsPlan.name][0], planGroupsPlan.name)
                if(planGroupsPlan.name.includes('Life Insurance') && "Life Insurance".includes(additionalDetails?.name?.split('-')[0].trim()) && this.hasKeys(planGroupsPlan.productAddonss[planGroupsPlan.name][0].member) ){
                  this.plansData[a].groups['43'][b].plans[c].productAddonss[planGroupsPlan.name][0].member.maximumCoverageWithoutEvidence = this.memberInsurance.lifeInsuranceCoverage 
                }
                if(planGroupsPlan.name.includes('Life Insurance') && "Life Insurance".includes(additionalDetails?.name?.split('-')[0].trim()) && this.hasKeys(planGroupsPlan.productAddonss[planGroupsPlan.name][0].spouse) ){
                  this.plansData[a].groups['43'][b].plans[c].productAddonss[planGroupsPlan.name][0].spouse.maximumCoverageWithoutEvidence = this.spouseInsurance.lifeInsuranceCoverage 
                }
                if(planGroupsPlan.name.includes('Critical Illness Insurance') && "Critical Illness Insurance".includes(additionalDetails?.name?.split('-')[0].trim()) && this.hasKeys(planGroupsPlan.productAddonss[planGroupsPlan.name][0].member) ){
                  this.plansData[a].groups['43'][b].plans[c].productAddonss[planGroupsPlan.name][0].member.maximumCoverageWithoutEvidence = this.memberInsurance.criticalIllnessCoverage 
                }
                if(planGroupsPlan.name.includes('Critical Illness Insurance') && "Critical Illness Insurance".includes(additionalDetails?.name?.split('-')[0].trim()) && this.hasKeys(planGroupsPlan.productAddonss[planGroupsPlan.name][0].spouse) ){
                  this.plansData[a].groups['43'][b].plans[c].productAddonss[planGroupsPlan.name][0].spouse.maximumCoverageWithoutEvidence = this.spouseInsurance.criticalIllnessCoverage 
                }
              }
            }
          }
        }
      }
      else {
      }
    }, (error) => {
    });
  }

  public onCheckboxChangeP(
    event: any,
    type: string,
    category: string,
    key1: string,
    value1: any,
    key2?: string,
    value2?: any
  ): void {

    console.log(this.allFormData)
    console.log(value1)
    console.log(value1?.member)
    if (category == 'member') {
      this.updateFormData(type, 'member', { coverage: value1.member })
    }
    if (category == 'spouse') {
      if (this.having_spouse == true) {
        this.updateFormData(type, 'spouse', { coverage: value1.spouse });
      }
    }

    let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    if (event.target.checked) {
      this.updateFormData(type, category, { [key1]: value1 });
    } else {
      console.log(type)
      console.log(category)
      this.updateFormData(type, category, {}, true);

      if (category == 'spouse') {
        this.updateFormData(type, 'member', {}, true);


        const planCheck = this.renderer?.selectRootElement("#planCheckLife" + type + "-" + 'MEMBER', true);
        this.renderer.setProperty(planCheck, 'checked', false);
      }
      if (category == 'member') {
        this.updateFormData(type, 'spouse', {}, true);

        planSummaryLife.forEach((element: any, index: any) => {

          if (element.coverage == 'MEMBER & SPOUSE') {
            const planCheck = this.renderer?.selectRootElement("#planCheckLife" + type + "-" + 'SPOUSE', true);
            this.renderer.setProperty(planCheck, 'checked', false);
          }
        })
      }
      this.unselectplanLife(event)
    }
    this.isAvailableCache={}
    this.spouseDataCache={}
    this.spouseCache={}
  }
  sideBarDisplay(value: string) {
    this.displaySideBar = JSON.parse(value);
    if (JSON.parse(value)) {
      this.width = "0"
    }
  }

  public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) { }

  public updateFormData(
    type: string,
    category: string,
    newData: any,
    remove: boolean = false
  ): void {
    if (this.lastUpdatedType !== type) {
      this.formData = this.allFormData[type]
        ? { ...this.allFormData[type] }
        : {};
    }

    let updatedFormData = { ...this.formData };
    let shouldUpdateTotal = false;
    console.log(updatedFormData)
    if (remove) {
      delete updatedFormData[category];
      delete updatedFormData.total;
    } else if (typeof newData === "object" && newData !== null) {
      updatedFormData[category] = { ...updatedFormData[category], ...newData };
      shouldUpdateTotal = "coverage" in newData || category === "dependent" || "isSmoker" in newData;
    } else {
      updatedFormData[category] = newData;
    }

    if (
      shouldUpdateTotal &&
      ["member", "spouse", "dependent"].includes(category)
    ) {
      updatedFormData.total = this.updateTotal(updatedFormData);
    }

    this.formData = updatedFormData;
    this.allFormData[type] = { ...this.formData };
    this.lastUpdatedType = type;
    console.log("formData:", this.allFormData);
  }


  public updatePremium(
    type: string,
    category: string,
    newIsSmokerValue: string
  ) {

    console.log(type, category, newIsSmokerValue, this.allFormData)

    const coverage = this.allFormData[type][category]?.coverage.maximumCoverageWithoutEvidence / 25000;
    const isSmoker = newIsSmokerValue === "yes" ? "smoker" : "nonSmoker";
    console.log('isSmoker', isSmoker, newIsSmokerValue)
    let value: any = 0;
    let gender: any = this.userForm.value.gender?.toLowerCase() != '' ? this.userForm.value.gender?.toLowerCase(): this.customerData.gender.toLowerCase()
    let spouseGender: any = this.userForm.value.spousegender?.toLowerCase() !='' ? this.userForm.value.spousegender?.toLowerCase() : this.customerData.spouseInfo?.gender.toLowerCase()


    console.log({ gender, spouseGender }, isSmoker)

    console.log(this.allFormData, type,category,gender,isSmoker)
    if (category === "member") {
      value = this.allFormData[type][category]?.["coverage"]["price"][gender][isSmoker]
    }
    
    if (category === "spouse") {
      value = this.allFormData[type][category]?.["coverage"]["price"][spouseGender][isSmoker]
    }
    
    console.log({ value })

    this.updateFormData(type, category, { constant: value });

    if (coverage > 0) {

      const premium = (coverage * value);
      return parseFloat(premium.toFixed(2));
    }
    console.log("formData:", this.allFormData);
    return 0;

  }

  getCoverageKey(plan: any): string {
  if (!plan?.name) {
    return plan?.planCoverage || '';
  }

  const normalized = plan?.name
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/-/g, '');

  if (normalized?.includes('lifeinsurance')) {
    return 'LIFE';
  }

  if (normalized?.includes('criticalillnessinsurance')) {
    return 'CRITICAL_ILLNESS';
  }

  return plan?.planCoverage??'';
}






  isDataAvailable(type: string, category: string, field?: string): boolean {
  const cacheKey = `${type}-${category}-${field || ''}`;

  if (this.isAvailableCache[cacheKey] !== undefined) {
    return this.isAvailableCache[cacheKey];
  }

  const bool = field
    ? this.allFormData[type]?.[category]?.[field] === undefined
    : this.allFormData[type]?.[category] === undefined;

  this.isAvailableCache[cacheKey] = bool;
  return bool;
}

  // isDataAvailableSpouseDataa(type: string, category: string, feild?: string): boolean {
  //   // console.log(this.allFormData)
  //   // console.log(type)
  //   // console.log(category)
  //   // console.log(feild)
  //   const cacheKey = `${type}-${category}-${feild || ''}`;




  isDataAvailableSpouseDataa(type: string, category: string, field?: string): boolean {
  const cacheKey = `${type}-${category}-${field || ''}`;

  if (this.spouseDataCache[cacheKey] !== undefined) {
    return this.spouseDataCache[cacheKey];
  }

  const bool = field
    ? this.allFormData[type]?.[category]?.[field] === undefined
    : this.allFormData[type]?.[category] === undefined;

  this.spouseDataCache[cacheKey] = bool;
  return bool;
}


  isDataAvailableSpouse(type: string, category: string): boolean {
  const cacheKey = `${type}-${category}`;

  if (this.spouseCache[cacheKey] !== undefined) {
    return this.spouseCache[cacheKey];
  }

  const hasMemberData = this.allFormData[type]?.member !== undefined;
  const bool = !hasMemberData;

  this.spouseCache[cacheKey] = bool;
  return bool;
}










  public getSliderBackground(
    rangeValue: any,
    maxRange: any,
    stepCount: any,
    defaultRange:any
  ): any {
    const percentage = (rangeValue / maxRange) * 100;
    let gradientColor = "white";
 
 
 
 
 
    if (rangeValue<= defaultRange) {
      this.activeValuePosition = percentage;
      this.greenValue =(defaultRange / maxRange)*100;
      this.names= [
        { label: 'Guaranteed', position: this.greenValue },    // Display "Start" at 0%
        { label: 'Pending', position: 100-this.greenValue}, // Display "Quarter" at 25%
 
      ];
      this.showyellowbar =false
      return `linear-gradient(to right, green ${(defaultRange / maxRange)*100}%, lightgray 0%)`;
    } else if (rangeValue > defaultRange) {
 
      this.showyellowbar =true
      const greenPart = this.adjustWith2DecimalsForUI((defaultRange / maxRange)*100);
      this.yellowValue =this.adjustWith2DecimalsForUI((100-greenPart)*100);
 
      const yellowPart =this.adjustWith2DecimalsForUI((rangeValue / maxRange)*100)
 
      this.names= [
        { label: 'Guaranteed', position: greenPart },    // Display "Start" at 0%
        { label: 'Pending', position: yellowPart}, // Display "Quarter" at 25%
 
      ];
      return `linear-gradient(to right,  green 0%,
    green ${greenPart}%,
    yellow ${greenPart}%,
    yellow ${yellowPart}%,
    lightgray  ${yellowPart}%,
    lightgray  100%)`;
 
 
    }
  }

  public handleRadioChange(event: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,value:any): void {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let isSmokerValue = event.target.value;
    let plandetails = event.target.attributes.data.value;
 
    let plandetailsobj = plandetails.split('##');
    let smokerCheck:any =''
 
    if(isSmokerValue=="no"){
      smokerCheck=false
    }
    else{
      smokerCheck =true
    }
 
    this.rangeValues =[]
 
 
    this.allFormData[type][category].coverage=value
 
    if (this.allFormData[type][category]) {
 
      this.updateFormData(type, category, {
        isSmoker: isSmokerValue,
        premium: this.updatePremium(type, category, isSmokerValue),
      });
    }
 
    console.log(this.allFormData)
let lifeCoverage=''
let memberObj:any={}
let spouseObj:any={}
 
if(category=="member"){
  lifeCoverage="MEMBER"
}
else{
lifeCoverage="MEMBER & SPOUSE"
}
 
if(this.allFormData[type]['spouse']){
  lifeCoverage="MEMBER & SPOUSE"
 
}
 
 
 
 
 
 
 
    plansummaryLife.forEach((element:any,index:any) => {
 
      if(element.planname==plandetailsobj[14]){
        plansummaryLife.splice(index,1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
 
    })
    let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000):0
    let spousePrice:any;
    if(this.allFormData[type]['spouse']){
      spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000):0
      }
 
 
    setTimeout(() => {
 
      let obj: any = {
        isBundle: plan.isBundle,
        categorization:{
          paidByCompany: 0,
          coveredByCompany: 0,
          paidByEmployee: 1
        },
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? toLegacyUsDate(
              this.userForm.value.planEnrollmentDate
            )
          : undefined,
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        planCoverage: plandetailsobj[2],
        planPrice: this.adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          this.adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version:plan.version,
        description: plan.description,
        insuranceType:plan.insuranceType
 
        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
     ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: this.adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version:product.version
      };
 
      this.productobj.total = this._decimalPipe
      .transform(
        this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
        '1.2-2'
      )
      ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
      .transform(
        this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
        '1.2-2'
      )
      ?.replace(/,/g, '')
 
 
      if(category=="member"){
 
        memberObj={
      "planStartDate":this.userForm.value.planEnrollmentDate
      ? toLegacyUsDate(
          this.userForm.value.planEnrollmentDate
        )
      : undefined,
      "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
      "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
      "coverage":"MEMBER",
      "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
      this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
      "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
      this.allFormData[type]["member"].coverage.defaultRange?true:false,
 
      "guaranteedAcceptanceAmount":this.adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type][category].constant)),
      "pendingApprovalAmount":this.adjustWith2DecimalsForUI(memberPrice*this.allFormData[type][category].constant )||0,
      "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
      "age":this.allFormData[type]["member"].coverage.age,
      "gender":this.userForm.value.gender?.toLowerCase(),
      "province":"ON",
      "provinceId":12,
      "amount":this.allFormData[type]["member"].premium,
      "tax": this.adjustWith2DecimalsForUI(this.productobj.tax),
      "taxRate":"", //not mandatory,
      "taxName":"",
      "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
      "premium":this.allFormData[type]["member"].constant,
      "total":this.adjustWith2DecimalsForUI(this.productobj.total),
      "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
      "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
      "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
      "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
      "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
        }
 
        memberObj["guaranteedAcceptanceTax"] = this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax)
        memberObj["guaranteedAcceptanceTotal"] =this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total)
 
        memberObj["pendingApprovalTax"] = this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax)
        memberObj["pendingApprovalTotal"] = this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total)
 
        obj["member"]= memberObj
        obj["spouse"]= {}
        if(this.allFormData[type]['spouse']){
        spouseObj={
          "planStartDate":this.userForm.value.planEnrollmentDate
  ? toLegacyUsDate(
      this.userForm.value.planEnrollmentDate
    )
  : undefined,
          "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage":"MEMBER & SPOUSE",
          "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
  this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
  "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
  this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
  "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
  "pendingApprovalAmount":this.adjustWith2DecimalsForUI(spousePrice*this.allFormData[type][category].constant )||0,
          "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
          "age":this.allFormData[type]["spouse"].coverage.age,
          "gender":this.userForm.value.spousegender?.toLowerCase(),
          "province":"ON",
          "provinceId":12,
          "amount":this.allFormData[type]["spouse"].premium,
          "tax":this.adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate":"", //not mandatory,
          "taxName":"",
          "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium":this.allFormData[type]["spouse"].constant,
          "total":this.adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
            }
 
 
 
 
 
 
        obj["member"]= memberObj
        obj["spouse"]= spouseObj
 
        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),product.taxesDataJSON??[]).tax
        spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),product.taxesDataJSON??[]).total
 
        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type][category].constant,product.taxesDataJSON??[]).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type][category].constant,product.taxesDataJSON??[]).total
          }
      }
      else{
 
        memberObj={
          "planStartDate":this.userForm.value.planEnrollmentDate
      ? toLegacyUsDate(
          this.userForm.value.planEnrollmentDate
        )
      : undefined,
          "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage":"MEMBER",
          "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
          this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
          "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
          this.allFormData[type]["member"].coverage.defaultRange?true:false,
          "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
 
          "pendingApprovalAmount":this.adjustWith2DecimalsForUI(memberPrice*this.allFormData[type][category].constant )||0,
          "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
          "age":this.allFormData[type]["member"].coverage.age,
          "gender":this.userForm.value.gender?.toLowerCase(),
          "province":"ON",
          "provinceId":12,
          "amount":this.allFormData[type]["member"].premium,
          "tax": this.adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate":"", //not mandatory,
          "taxName":"",
          "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium":this.allFormData[type]["member"].constant,
          "total":this.adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
            }
            spouseObj={
              "planStartDate":this.userForm.value.planEnrollmentDate
      ? toLegacyUsDate(
          this.userForm.value.planEnrollmentDate
        )
      : undefined,
              "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
              "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
              "coverage":"MEMBER & SPOUSE",
              "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
      this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
      "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
      this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
      "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type][category].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
      "pendingApprovalAmount":this.adjustWith2DecimalsForUI(spousePrice*this.allFormData[type][category].constant )||0,
              "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
              "age":this.allFormData[type]["spouse"].coverage.age,
              "gender":this.userForm.value.spousegender?.toLowerCase(),
              "province":"ON",
              "provinceId":12,
              "amount":this.allFormData[type]["spouse"].premium,
              "tax":this.adjustWith2DecimalsForUI(this.productobj.tax),
              "taxRate":"", //not mandatory,
              "taxName":"",
              "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
              "premium":this.allFormData[type]["spouse"].constant,
              "total":this.adjustWith2DecimalsForUI(this.productobj.total),
              "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
              "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
              "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
              "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
              "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
                }
 
      obj["member"]= memberObj
      obj["spouse"]= spouseObj
 
 
      memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
      memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total
 
      spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
      spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total
 
      memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax
      memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total
 
      spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type]["spouse"].constant,product.taxesDataJSON??[]).tax
      spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type]["spouse"].constant,product.taxesDataJSON??[]).total
 
      }
 
      let MSguranteeAcceptanceAmount = this.adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"]+(spouseObj["guaranteedAcceptanceAmount"]??0))
      let MSguranteeAcceptancetTAX = this.adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"]+(spouseObj["guaranteedAcceptanceTax"]??0))
      let MSguranteeAcceptancetTotal = this.adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"]+(spouseObj["guaranteedAcceptanceTotal"]??0))
 
      let MSpendingApprovalAmount = this.adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"]+(spouseObj["pendingApprovalAmount"]??0))
      let MSpendingApprovalTAX = this.adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"]+(spouseObj["pendingApprovalTax"]??0))
      let MSpendingApprovalTotal = this.adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"]+(spouseObj["pendingApprovalTotal"]??0))
 
      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,
 
        planproductname: this.productobj.name,
 
        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version:plan.version,
        guaranteedAcceptanceDetails:{
          "amount":MSguranteeAcceptanceAmount,
          "tax":MSguranteeAcceptancetTAX,
          "total":MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: this.adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version:product.version,
            total :this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
            tax : this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, '')
          }]
 
 
        },
        pendingApprovalDetails:{
          "amount":MSpendingApprovalAmount,
          "tax":this._decimalPipe
          .transform(
            this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
          "total":this._decimalPipe
          .transform(
            this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: this.adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version:product.version,
            total :this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
            tax : this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, '')
          }]
        },
        selectedDetails:{
          "amount": this.adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total":this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]).total : 0),
 
          "tax" :this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]).tax : 0),
          "products":[this.productobj]
        }
 
 
      };
 
      obj["guaranteedAcceptanceDetails"]=obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"]=obj1.pendingApprovalDetails
      obj["selectedDetails"]=obj1.selectedDetails
      obj1.products.push(this.productobj);
 
      if (obj.member.coverageValue > obj.member.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeMember = false;
        this.hasMember=true;
      }
      if (obj.member.coverageValue > obj.member.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalMember = false
        this.hasMember=true;
      }
      if (obj.spouse.coverageValue > obj.spouse.defaultRange && obj.planCoverage == "LIFE") {
        this.having_spouse=true
        this.lifeSpouse = false
      }
      if (obj.spouse.coverageValue > obj.spouse.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalSpouse = false
        this.having_spouse=true
      }
      if (obj.member.coverageValue <= obj.member.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeMember = true
        this.hasMember=true;
      }
      if (obj.member.coverageValue <= obj.member.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalMember = true
        this.hasMember=true;
      }
      if (obj.spouse.coverageValue <= obj.spouse.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeSpouse = true
      }
      if (obj.spouse.coverageValue <= obj.spouse.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalSpouse = true
      }
      this.isSpouse=this.having_spouse
      console.log('btn status updated', this.lifeMember, this.lifeSpouse, this.criticalMember, this.criticalSpouse)
      this.addtoplansummaryLife(obj, obj1);
      this.isAvailableCache={}
      this.spouseDataCache={}
      this.spouseCache={}
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }
 
 
    /*
    Form Here the code works for auto slection of Smoker in Life and critical vice versa
     */
 
    plansummaryLife.forEach((element:any,index:any) => {
 
 
      if(category=="member"){
 
          if(element.member.smoker==isSmokerValue){
        }
        else{
 
 
          const dom: HTMLElement = this.elementRef.nativeElement;
 
          const plan: any = dom.querySelector("."+"member"+"-" + element.planCoverage + "-"+isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan?.click()
          }, 1000);
 
      }
      }
      if(category=="spouse"){
 
 
          if(element.spouse.smoker==isSmokerValue){
        }
        else{
 
 
          const dom: HTMLElement = this.elementRef.nativeElement;
 
          const plan: any = dom.querySelector("."+"spouse"+"-" + element.planCoverage + "-"+isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan?.click()
          }, 1000);
 
      }
      }
 
 
 
 
  })
  }

  public handleRangeChange(value: any, type: string, category: string,options:any,plan:any,product:any,pckage:any,group:any,event:any,data:any): void {
    console.log(value)
    console.log(type)
    console.log(event)
    console.log(data)
    console.log(this.allFormData)

    if(type=='LIFE'&&category=="member" && this.lifePlans?.length>0 && data.maximumCoverageWithoutEvidence<this.memberInsurance.lifeInsuranceCoverage){
      data.maximumCoverageWithoutEvidence=this.memberInsurance.lifeInsuranceCoverage
    }
    if(type=='LIFE'&&category=="spouse" && this.lifePlans?.length>0 && data.maximumCoverageWithoutEvidence<this.spouseInsurance.lifeInsuranceCoverage){
      data.maximumCoverageWithoutEvidence=this.spouseInsurance.lifeInsuranceCoverage
    }
    if(type=='CRITICAL_ILLNESS'&&category=="member" && this.lifePlans?.length>0 && data.maximumCoverageWithoutEvidence<this.memberInsurance.criticalIllnessCoverage){
      data.maximumCoverageWithoutEvidence=this.memberInsurance.criticalIllnessCoverage
    }
    if(type=='CRITICAL_ILLNESS'&&category=="spouse" && this.lifePlans?.length>0 && data.maximumCoverageWithoutEvidence<this.spouseInsurance.criticalIllnessCoverage){
      data.maximumCoverageWithoutEvidence=this.spouseInsurance.criticalIllnessCoverage
    }
 
    if(data.maximumCoverageWithoutEvidence==0){
      data.maximumCoverageWithoutEvidence=25000
    }
    this.allFormData[type][category].coverage=data
 
 
 
    this.rangeValues = [];
 
 
 
 
    if (this.allFormData[type][category]) {
      this.updateFormData(type, category, {
        isSmoker: this.allFormData[type][category].isSmoker,
        premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
      });
    }
    let lifeCoverage=''
    let memberObj:any={}
let spouseObj:any={}
if(category=="member"){
  lifeCoverage="MEMBER"
}else{
lifeCoverage="MEMBER & SPOUSE"
}
 
if(this.allFormData[type]['spouse']){
  lifeCoverage="MEMBER & SPOUSE"
 
}
    console.log(this.plansData)
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
 
 
    let plandetails = event.target.attributes.data.value;
 
    let plandetailsobj = plandetails.split('##');
 
 
    plansummaryLife.forEach((element:any,index:any) => {
 
      if(element.planname==plandetailsobj[14]){
        plansummaryLife.splice(index,1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
 
    })
    setTimeout(() => {
 
      let obj: any = {
        isBundle: plan.isBundle,
        categorization:{
          paidByCompany: 0,
          coveredByCompany: 0,
          paidByEmployee: 1
        },
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? toLegacyUsDate(
              this.userForm.value.planEnrollmentDate
            )
          : undefined,
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        planCoverage: plandetailsobj[2],
        planPrice: this.adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          this.adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version:plan.version,
        description: plan.description,
        insuranceType:plan.insuranceType
 
        //  "disallowedPlanLevels":plandetailsobj[11]
      };
      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
     ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price:this.adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version:product.version
      };
 
      this.productobj.total = this._decimalPipe
      .transform(
        this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
        '1.2-2'
      )
      ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
      .transform(
        this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
        '1.2-2'
      )
      ?.replace(/,/g, '')
 
 
      let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000):0
      let spousePrice:any;
      if(this.allFormData[type]['spouse']){
        spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["spouse"].coverage.defaultRange)/25000):0
        }
      if(category=="member"){
 
        memberObj={
      "planStartDate":this.userForm.value.planEnrollmentDate
      ? toLegacyUsDate(
          this.userForm.value.planEnrollmentDate
        )
      : undefined,
      "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
      "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
      "coverage":"MEMBER",
      "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
      this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
      "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
      this.allFormData[type]["member"].coverage.defaultRange?true:false,
 
 
      "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
      "pendingApprovalAmount":this.adjustWith2DecimalsForUI(memberPrice*this.allFormData[type][category].constant )||0,
      "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
      "age":this.allFormData[type]["member"].coverage.age,
      "gender":this.userForm.value.gender?.toLowerCase(),
      "province":"ON",
      "provinceId":12,
      "amount":this.allFormData[type]["member"].premium,
      "tax": this.adjustWith2DecimalsForUI(this.productobj.tax),
      "taxRate":"", //not mandatory,
      "taxName":"",
      "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
      "premium":this.allFormData[type]["member"].constant,
      "total":this.adjustWith2DecimalsForUI(this.productobj.total),
      "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
      "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
      "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
      "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
      "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
        memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total
 
        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total
 
        obj["member"]= memberObj
        obj["spouse"]= {}
 
        if(this.allFormData[type]['spouse']){
          spouseObj={
            "planStartDate":this.userForm.value.planEnrollmentDate
    ? toLegacyUsDate(
        this.userForm.value.planEnrollmentDate
      )
    : undefined,
            "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage":"MEMBER & SPOUSE",
            "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
    this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
    "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
    this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
    "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),
    "pendingApprovalAmount":this.adjustWith2DecimalsForUI(spousePrice*this.allFormData[type][category].constant )||0,
            "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
            "age":this.allFormData[type]["spouse"].coverage.age,
            "gender":this.userForm.value.spousegender?.toLowerCase(),
            "province":"ON",
            "provinceId":12,
            "amount":this.allFormData[type]["spouse"].premium,
            "tax":this.adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate":"", //not mandatory,
            "taxName":"",
            "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium":this.allFormData[type]["spouse"].constant,
            "total":this.adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
              }
 
 
 
 
 
 
          obj["member"]= memberObj
          obj["spouse"]= spouseObj
 
          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
          spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total
 
          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type]["spouse"].constant,product.taxesDataJSON??[]).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type]["spouse"].constant,product.taxesDataJSON??[]).total
            }
 
 
 
 
      }
      else{
 
        memberObj={
          "planStartDate":this.userForm.value.planEnrollmentDate
      ? toLegacyUsDate(
          this.userForm.value.planEnrollmentDate
        )
      : undefined,
          "units":(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits":this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage":"MEMBER",
          "guaranteedAcceptance":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
          this.allFormData[type]["member"].coverage.defaultRange?true:false, //defalutRange
          "pendingMedicalQuestionaire":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
          this.allFormData[type]["member"].coverage.defaultRange?true:false,
          "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),
          "pendingApprovalAmount":this.adjustWith2DecimalsForUI(memberPrice*this.allFormData[type][category].constant )||0,
          "smoker":this.allFormData[type]["member"].isSmoker=="yes"?true:false,
          "age":this.allFormData[type]["member"].coverage.age,
          "gender":this.userForm.value.gender?.toLowerCase(),
          "province":"ON",
          "provinceId":12,
          "amount":this.allFormData[type]["member"].premium,
          "tax":this.adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate":"", //not mandatory,
          "taxName":"",
          "coverageValue":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium":this.allFormData[type]["member"].constant,
          "total":this.adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice":this.allFormData[type]["member"].coverage.coverageUnitPrice,
      "defaultRange":this.allFormData[type]["member"].coverage.defaultRange,
      "maximumCoverageWithEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
      "maximumCoverageWithoutEvidence":this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
      "minimumCoverage":this.allFormData[type]["member"].coverage.minimumCoverage,
            }
            spouseObj={
              "planStartDate":this.userForm.value.planEnrollmentDate
      ? toLegacyUsDate(
          this.userForm.value.planEnrollmentDate
        )
      : undefined,
              "units":(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/this.allFormData[type][category].coverage.minimumCoverage),
              "standardUnits":this.allFormData[type]["spouse"].coverage.minimumCoverage,
              "coverage":"MEMBER & SPOUSE",
              "guaranteedAcceptance":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
      this.allFormData[type]["spouse"].coverage.defaultRange?true:false, //defalutRange
      "pendingMedicalQuestionaire":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
      this.allFormData[type]["spouse"].coverage.defaultRange?true:false,
      "guaranteedAcceptanceAmount":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type][category].constant),
      "pendingApprovalAmount":this.adjustWith2DecimalsForUI(spousePrice*this.allFormData[type][category].constant )||0,
      "smoker":this.allFormData[type]["spouse"].isSmoker=="yes"?true:false,
              "age":this.allFormData[type]["spouse"].coverage.age,
              "gender":this.userForm.value.spousegender?.toLowerCase(),
              "province":"ON",
              "provinceId":12,
              "amount":this.allFormData[type]["spouse"].premium,
              "tax":this.adjustWith2DecimalsForUI(this.productobj.tax),
              "taxRate":"", //not mandatory,
              "taxName":"",
              "coverageValue":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
              "premium":this.allFormData[type]["spouse"].constant,
              "total":this.adjustWith2DecimalsForUI(this.productobj.total),
              "coverageUnitPrice":this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
      "defaultRange":this.allFormData[type]["spouse"].coverage.defaultRange,
      "maximumCoverageWithEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
      "maximumCoverageWithoutEvidence":this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
      "minimumCoverage":this.allFormData[type]["spouse"].coverage.minimumCoverage,
                }
 
      obj["member"]= memberObj
      obj["spouse"]= spouseObj
 
 
      memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).tax
      memberObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["member"].constant):((this.allFormData[type]["member"].coverage.defaultRange/25000)*this.allFormData[type]["member"].constant),product.taxesDataJSON??[]).total
      spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).tax
      spouseObj["guaranteedAcceptanceTotal"] =this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=this.allFormData[type]["spouse"].coverage.defaultRange?((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence/25000)*this.allFormData[type]["spouse"].constant):((this.allFormData[type]["spouse"].coverage.defaultRange/25000)*this.allFormData[type]["spouse"].constant),product.taxesDataJSON??[]).total
 
      memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax
      memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total
 
      spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax
      spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total
 
      }
 
 
      console.log(memberObj["pendingApprovalTax"])
      let MSguranteeAcceptanceAmount = this.adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"]+(spouseObj["guaranteedAcceptanceAmount"]??0))
      let MSguranteeAcceptancetTAX = this.adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"]+(spouseObj["guaranteedAcceptanceTax"]??0))
      let MSguranteeAcceptancetTotal = this.adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"]+(spouseObj["guaranteedAcceptanceTotal"]??0))
 
      let MSpendingApprovalAmount = this.adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"]+(spouseObj["pendingApprovalAmount"]??0))
      let MSpendingApprovalTAX = this.adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"]+(spouseObj["pendingApprovalTax"]??0))
      let MSpendingApprovalTotal = this.adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"]+(spouseObj["pendingApprovalTotal"]??0))
 
      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,
 
        planproductname: this.productobj.name,
 
        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version:plan.version,
        guaranteedAcceptanceDetails:{
          "amount":MSguranteeAcceptanceAmount,
          "tax":MSguranteeAcceptancetTAX,
          "total":MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: this.adjustWith2DecimalsForUI(MSguranteeAcceptanceAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version:product.version,
            total :this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
            tax : this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount,product.taxesDataJSON??[]).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, '')
          }]
 
 
        },
        pendingApprovalDetails:{
          "amount":MSpendingApprovalAmount,
          "tax":this._decimalPipe
          .transform(
            this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
          "total":this._decimalPipe
          .transform(
            this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: this.adjustWith2DecimalsForUI(MSpendingApprovalAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version:product.version,
            total :this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
            tax : this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount,product.taxesDataJSON??[]).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, '')
          }]
        },
        selectedDetails:{
          "amount": this.adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total":this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]).total : 0),
 
          "tax" :this.adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total,product.taxesDataJSON??[]).tax : 0),
          "products":[this.productobj]
        }
 
 
      };
 
      obj["guaranteedAcceptanceDetails"]=obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"]=obj1.pendingApprovalDetails
      obj["selectedDetails"]=obj1.selectedDetails
      if (obj.member.coverageValue > obj.member.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeMember = false;
        this.hasMember=true;
      }
      if (obj.member.coverageValue > obj.member.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalMember = false
        this.hasMember=true;
      }
      if (obj.spouse.coverageValue > obj.spouse.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeSpouse = false
      }
      if (obj.spouse.coverageValue > obj.spouse.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalSpouse = false
      }
      if (obj.member.coverageValue <= obj.member.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeMember = true
        this.hasMember=true;
      }
      if (obj.member.coverageValue <= obj.member.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalMember = true
        this.hasMember=true;
      }
      if (obj.spouse.coverageValue <= obj.spouse.defaultRange && obj.planCoverage == "LIFE") {
        this.lifeSpouse = true
      }
      if (obj.spouse.coverageValue <= obj.spouse.defaultRange && obj.planCoverage == "CRITICAL_ILLNESS") {
        this.criticalSpouse = true
      }
      this.isSpouse=this.having_spouse
      console.log('btn status updated', this.lifeMember, this.lifeSpouse, this.criticalMember, this.criticalSpouse, this.isSpouse)
      obj1.products.push(this.productobj);
      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }
  }

 getAmount(amount){
  return Number(amount).toFixed(2)
 }

  public unselectplanLife(elementcv: any) {

    console.log(elementcv)

    let plandetails = elementcv.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? toLegacyUsDate(this.userForm.value.planEnrollmentDate)
        : undefined,
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryLife(obj);
  }

  public addtoplansummaryLife(obj: any, obj1: any) {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


    this.addtoslectplans(obj.id, plansummaryLife.length);
    plansummaryLife.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;


    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');


    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymainLife = [];
    this.planssummaryopt = [];

    plansummaryLife.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymainLife.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    console.log(this.plansskumain, obj, 'obj123')
    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'planssummarymainLife',
      JSON.stringify(this.planssummarymainLife)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (plansummaryLife.length > 0 || planSummaryData.length > 0) {
      this.plansnexttab = false;
    } else {
      this.plansnexttab = true;
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }

  public removeplansummaryLife(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        planSummary.splice(index, 1);
        ////this.consoleMessage("afterremove")
        ////this.consoleMessage(planSummary)
      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymainLife = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymainLife.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'planssummarymainLife',
        JSON.stringify(this.planssummarymainLife)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummaryLife', JSON.stringify(planSummary));
      let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

      if (planSummary.length > 0 || planSummaryData.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {


      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      this.planAmount = this._decimalPipe.transform(total, '1.2-2')?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);
  }

  public updateTotal(data: any) {
    const memberPremium =
      data.member && data.member.premium > 0 ? data.member.premium : 0;
    const spousePremium =
      data.spouse && data.spouse.premium > 0 ? data.spouse.premium : 0;
    const dependentPremium =
      data.dependent && data.dependent.premium > 0 ? data.dependent.premium : 0;
    const total = memberPremium + spousePremium + dependentPremium;

    return total;
  }

  public calculateTaxForProductTaxesData(price: number, taxesData: any) {
    let calculatedTax: any = {}
    let tax: any = 0;
    let planProductIds: any = []
    let planProductInfos: any = []
    if (taxesData && taxesData != undefined && taxesData != null && taxesData != "null") {
      for (const taxData of taxesData) {
        tax += this.adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductIds.push(taxData.plan_product_id);
        let planProductInfo: any = {};
        planProductInfo.name = taxData.tax_name;
        planProductInfo.description = taxData.tax_description;
        planProductInfo.price = this.adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductInfo.planProductUniqueId = taxData.plan_product_id;
        planProductInfo.isIncluded = true;
        planProductInfo.taxRate = taxData.tax_rate;
        planProductInfo.taxRatePercentage = this.adjustWith2DecimalsForUI((taxData.tax_rate) * 100) + "%";
        planProductInfos.push(planProductInfo);
      }
    }

    let total = this.adjustWith2DecimalsForUI(price + tax)
    calculatedTax.price = this.adjustWith2DecimalsForUI(price);
    calculatedTax.tax = this.adjustWith2DecimalsForUI(tax);
    calculatedTax.total = this.adjustWith2DecimalsForUI(total);

    calculatedTax.planProductIds = planProductIds;
    calculatedTax.planProductInfos = planProductInfos;

    return calculatedTax;

  }
  public adjustWith2DecimalsForUI = (amount: any) => +parseFloat(amount.toString()).toFixed(2);

  public addtosum(amount: any) {


    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');

    return selectedPlansAmount;
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount')?.replace(/,/g, '') ?? '0'
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');
    return selectedPlansAmount;
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }
  public removeslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeremoveplans")
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );

    ////this.consoleMessage(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      ////this.consoleMessage(planid)
      ////this.consoleMessage(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    ////this.consoleMessage("adjustedselectedPlans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public getslectedplans(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }

  addNewPlans() {
    console.log('addNewPlans')
    let customerId = sessionStorage.getItem('customerId');
    const endPoint = `/customer/${customerId}/iafg/subscription/apply`


    
    











    //                   if (
    //                     !obj['hstCheck'] &&
    //                     !obj['gstCheck'] &&
    //                     !obj['pstCheck'] &&
    //                     !obj['qstCheck']
    //                   ) {
    //                     obj['taxUI'] += '<span>-';


                









    let plans:any= []
    let formData={};
 
 
      this.plansummaryLIFE = JSON.parse(sessionStorage.getItem("planssummarymainLife")||'')
      let planDetailsArrayBlock =JSON.parse(sessionStorage.getItem("planssummarymainLife")||'[]')
 
 
      this.plansummaryLIFE.forEach((element:any,index:number) => {
 
        element.member.maximumCoverageWithoutEvidence =element.member.defaultRange
        let enrolledDate = ''
        console.log(this.getFieldByName(element.name,'status'))
        if(this.getFieldByName(element.name,'status')=='Provisioning'){
          enrolledDate = this.getFieldByName(element.name,'enrolledDate').slice(0,10)
        }else{
          const now = new Date();
          enrolledDate =  `${now.getFullYear() +'-'+this.padWithZeros(now.getMonth()+2,2)+'-'+'01'}`;
        }
        element.member.planStartDate = enrolledDate
        element['planEnrollmentDate'] = enrolledDate
        
        if(element.spouse && element.spouse.maximumCoverageWithoutEvidence){
          element.spouse.maximumCoverageWithoutEvidence =element.spouse.defaultRange
          element.spouse.planStartDate = enrolledDate
        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$"+element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] =       element.guaranteedAcceptanceDetails.total
        element['totalPrice'] =       element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] =       element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$"+element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$"+element.guaranteedAcceptanceDetails.tax

        if(element.name.includes("Corporate")){
          console.log(element.name)
          element['companyCoveredBasePlan'] = {
            planId: element.id,
            planName: element.name,
            planLevelId: element.planLevel,
            planLevelName: element.planname,
            amount: element.amount,
          },
          element['upgradeCalculation'] = {}
        }else{
          delete element.categorization
        }

        this.plansummaryLIFEFinal.push(element)
 
      });
 
 
       planDetailsArrayBlock.forEach((element:any,index:number) => {
        if(element.id==13){
          this.iafgPlansAvailability =true
        }
        else{
          this.iafgPlansAvailability =false
        }
 
      });
 
 
      this.plansummaryLIFEFinal= this.plansummaryLIFEFinal.sort(function(a:any, b:any) {
        return (a.packageId - b.packageId);
      })

      this.plansummaryLIFEFinal.forEach((element:any) => {
 
      if(element.packageId ==1){
        this.provisioning =true
      }

      element.totalPrice = this._decimalPipe.transform(element.totalPrice,"1.2-2")?.replace(/,/g, "")
      element.total = this._decimalPipe.transform(element.totalPrice,"1.2-2")?.replace(/,/g, "")
      element.tax = this._decimalPipe.transform(element.tax,"1.2-2")?.replace(/,/g, "")
      element.amount = this._decimalPipe.transform(element.amount,"1.2-2")?.replace(/,/g, "")
      console.log(plans,element)
      plans.push(element)
      });

      console.log('plans',plans,this.plansummaryLIFE)
      plans.forEach(plan => {
      plan.total = Number(plan.total);
      plan.amount = Number(plan.amount);
      plan.tax = Number(plan.tax);
      plan.products.forEach(product => {
        product.tax = Number(product.tax);
        product.total = Number(product.total);
      });
    });
      formData["plans"]=plans;

    let totalAmount = plans?.reduce((acc: any, plan: any) => {
      return acc + Number(plan.total);
    }, 0);

    formData['totalAmount']= Number(totalAmount.toFixed(2));
    formData['totalAmountUI']= '$'+totalAmount.toFixed(2);
    formData['planEnrollmentDate'] = formData['plans'][0].planEnrollmentDate
    formData['currency'] = 'CAD'
    formData['currencySymbol'] = '$'

    var requestOptions:any = {
 
      method: 'POST',
      body: formData,
      redirect: 'follow'
   
    };

    console.log('formData',formData)

    this.http.post(api.url + endPoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        const responseData = response.data;
        console.log('responseData', responseData)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          .then((result) => {
            if(this.currClient){
              this.router.navigate([`${this.currClient}/home`]);
            }else{
              this.router.navigate(['home']);
            }
          })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        .then(result=>{
          this.router.navigate(["/home"])          
        })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }


  updatePlans() {
    console.log('updateplans')
    let customerId = sessionStorage.getItem('customerId');
    const endPoint = `/customer/${customerId}/iafg/subscription/upgrade`


    
    











    //                   if (
    //                     !obj['hstCheck'] &&
    //                     !obj['gstCheck'] &&
    //                     !obj['pstCheck'] &&
    //                     !obj['qstCheck']
    //                   ) {
    //                     obj['taxUI'] += '<span>-';


                









    
    let plans:any= []
    let formData={};
 
 
      this.plansummaryLIFE = JSON.parse(sessionStorage.getItem("planssummarymainLife")||'')
      let planDetailsArrayBlock =JSON.parse(sessionStorage.getItem("planssummarymainLife")||'[]')
 
 
      this.plansummaryLIFE.forEach((element:any,index:number) => {
 
        element.member.maximumCoverageWithoutEvidence =element.member.defaultRange
        let enrolledDate = ''
        console.log(this.getFieldByName(element.name,'status'))
        if(this.getFieldByName(element.name,'status')=='Provisioning'){
          enrolledDate = this.getFieldByName(element.name,'enrolledDate').slice(0,10)
        }else{
          const now = new Date();
          // next month date 1st date
          enrolledDate =  `${now.getFullYear() +'-'+this.padWithZeros(now.getMonth()+2,2)+'-'+'01'}`;
        }
        element.member.planStartDate = enrolledDate
        element['planEnrollmentDate'] = enrolledDate
        
        if(element.spouse && element.spouse.maximumCoverageWithoutEvidence){
          element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange
          element.spouse.planStartDate = enrolledDate
        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$"+element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] = element.guaranteedAcceptanceDetails.total
        element['totalPrice'] = element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$"+element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$"+element.guaranteedAcceptanceDetails.tax
        element['subscriptionId'] = this.getFieldByName(element.name,'subscriptionId') ?? ''
        element['taxSubscriptionId'] = this.getFieldByName(element.name,'taxSubscriptionId')

        if(element.name.includes("Corporate")){
          console.log(element.name)
          element['companyCoveredBasePlan'] = {
            planId: element.id,
            planName: element.name,
            planLevelId: element.planLevel,
            planLevelName: element.planname,
            amount: element.amount,
          },
          element['upgradeCalculation'] = {}
        }else{
          delete element.categorization
        }
 
        this.plansummaryLIFEFinal.push(element)
 
      });
 
 
       planDetailsArrayBlock.forEach((element:any,index:number) => {
        if(element.id==13){
          this.iafgPlansAvailability =true
        }
        else{
          this.iafgPlansAvailability =false
        }
 
      });
 
 
      this.plansummaryLIFEFinal= this.plansummaryLIFEFinal.sort(function(a:any, b:any) {
        return (a.packageId - b.packageId);
      })

      this.plansummaryLIFEFinal.forEach((element:any) => {
 
        if(element.packageId ==1){
          this.provisioning =true
        }
 
     element.totalPrice = this._decimalPipe.transform(element.totalPrice,"1.2-2")?.replace(/,/g, "")
     element.total = this._decimalPipe.transform(element.totalPrice,"1.2-2")?.replace(/,/g, "")
     element.tax = this._decimalPipe.transform(element.tax,"1.2-2")?.replace(/,/g, "")
     element.amount = this._decimalPipe.transform(element.amount,"1.2-2")?.replace(/,/g, "")
     console.log(plans,element)
      plans.push(element)
      });
      console.log('plans',plans,this.plansummaryLIFE)
      plans.forEach(plan => {
      plan.total = Number(plan.total);
      plan.amount = Number(plan.amount);
      plan.tax = Number(plan.tax);
      plan.products.forEach(product => {
        product.tax = Number(product.tax);
        product.total = Number(product.total);
      });
    });
      formData["plans"]=plans;

    let totalAmount = plans?.reduce((acc: any, plan: any) => {
      return acc + Number(plan.total);
    }, 0);

    formData['totalAmount']= Number(totalAmount.toFixed(2));
    formData['totalAmountUI']= '$'+totalAmount.toFixed(2);
    // formData['planEnrollmentDate'] = ''
    formData['planEnrollmentDate'] = formData['plans'][0].planEnrollmentDate
    formData['currency'] = 'CAD'
    formData['currencySymbol'] = '$'

    var requestOptions:any = {
 
      method: 'POST',
      body: formData,
      redirect: 'follow'
   
    };

    
    console.log('formData',formData)

    this.http.post(api.url + endPoint, formData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        const responseData = response.data;
        console.log('responseData', responseData)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
          .then((result) => {
             if(this.currClient){
                this.router.navigate([`${this.currClient}/home`]);
              }else{
                this.router.navigate(['home']);
              }
          })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
        .then(result=>{
          this.router.navigate(["/home"])          
        })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  padWithZeros = (value, length) => {
    return String(value).padStart(length, "0");
  };

  getFieldByName(name,field) {
    // Check if the name matches and return the subscriptionId
    for(let i=0;i<this.lifePlans.length;i++){
      let plans = this.lifePlans[i]
      if (plans.name === name) {
        return plans[field];
      }
    }
    return null; // Return null if no match is found
  }

  navigateToHome() {
    this.router.navigate([`home`]);
  }

  hasKeys(value) {
    return value && Object.keys(value).length > 0
  }

  getFormConfiguration(lang: any) {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = '/customer/formConfig';
    this.http.get(api.url+customerDataEndpoint, {
      headers:{
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
        'Lang': lang,
    }}).subscribe((response:any)=>{

      if(response.status==200) {
        this.formConfig = response.data;
        console.log(this.formConfig)
        const provinces = response.data.states.sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );  
        this.configprovinceres = provinces;
        this.provinceList = provinces.map(province=>province.shortName) 
      }
      else {
        Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
      }
    },(error) => {
      Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });
  }

  getCustomerData() {
    let customerDataEndpoint = '/customer/' + this.customerid + '/details';
    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.customerData = response.data;
        console.log('this.customerData', this.customerData)

        this.memberDetails.lastName = this.customerData.lastName
        this.memberDetails.firstName = this.customerData.firstName
        this.memberDetails.gender = this.customerData.gender
        this.memberDetails.dob = parseDateOnly(this.customerData.dob)
        this.memberDetails.pob = ''
        this.memberDetails.occupation = ''
        this.memberDetails.streetAddress = this.customerData.line1
        this.memberDetails.city = this.customerData.city
        this.memberDetails.province = this.customerData.province
        this.memberDetails.postalCode = this.customerData.postalCode
        this.memberDetails.telephone = this.customerData.primaryPhone
        this.memberDetails.telephone2Type = ''
        this.memberDetails.secondaryPhone = this.customerData.secondaryPhone
        this.memberDetails.email = this.customerData.email || this.customerData.primaryEmail
        this.memberDetails.memberSignature = this.customerData?.signature ? this.customerData?.signature : ''
        console.log('this.memberDetails', this.memberDetails)
        this.answers = [
          { questionNumber: '3', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '4', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '5', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '6', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '7', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '8', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '9', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '10', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '11', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '12', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '13', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '14a', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '14b', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '15', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '16', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '17', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '18', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '19', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '20', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '21', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '22', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '23', value: this.memberDetails.firstName, additionalDetails: "" },
        ]

        this.isSpouse = this.customerData?.iafg?.pendingMedicalQuestionaireCoverage?.toUpperCase().includes('SPOUSE');

        if (this.isSpouse) {
          this.spouseDetails.alsoMember = ''
          this.spouseDetails.spouseStatus = ''
          this.spouseDetails.cohabitationDate = ''
          this.spouseDetails.lastName = this.customerData.dependents.spouseInfo?.lastName
          this.spouseDetails.firstName = this.customerData.dependents.spouseInfo?.lastName
          this.spouseDetails.gender = this.customerData.dependents.spouseInfo?.gender
          this.spouseDetails.dob = parseDateOnly(this.customerData.dependents.spouseInfo?.dob)
          this.spouseDetails.pob = this.customerData.dependents.spouseInfo?.pob
          this.spouseDetails.occupation = ''
          this.spouseDetails.spouseSignature = this.customerData?.spouseSignature ? this.customerData?.spouseSignature : ''
          console.log('this.spouseDetails', this.spouseDetails)
        }

        this.answers1 = [
          { questionNumber: '3', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '4', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '5', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '6', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '7', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '8', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '9', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '10', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '11', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '12', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '13', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '14a', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '14b', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '15', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '16', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '17', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '18', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '19', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '20', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '21', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '22', value: this.spouseDetails?.firstName, additionalDetails: "" },
          { questionNumber: '23', value: this.spouseDetails?.firstName, additionalDetails: "" },
        ]

        this.beneficiaries = this.customerData?.beneficiaries?.map(ben => {
          return {
            firstName: ben.firstName,
            lastName: ben.lastName,
            relationship: ben.relationship,
            percentagePayable: ben.percentage,
            trustee: ben.trusteeDetails
          }
        })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  getPlanes() {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerId = sessionStorage.getItem('customerId');
    let customerEndpoint = `/customer/v3/${customerId}/plans/false`;
    this.http.get(api.url + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'applivation/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.plans = response.data.plans;
        for (let i = 0; i < this.plans.length; i++) {
          let additionalDetails = JSON.parse(this.plans[i].additionalDetails) || []
          console.log({ additionalDetails })
          if ("Life Insurance".includes(additionalDetails?.name?.split('-')[0].trim())) {
            if (additionalDetails?.member && Object.keys(additionalDetails.member).length > 0) {
              this.memberInsurance.lifeInsurance = true
              this.memberInsurance.lifeInsuranceCoverage = additionalDetails?.member?.coverageValue
              this.insuranceForm.patchValue({
                memberQuestion1: additionalDetails?.member?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                gender: additionalDetails?.member?.gender
              });
            }
            if (additionalDetails?.spouse && Object.keys(additionalDetails.spouse).length > 0) {
              this.spouseInsurance.lifeInsurance = true
              this.spouseInsurance.lifeInsuranceCoverage = additionalDetails?.spouse?.coverageValue
              this.insuranceForm.patchValue({
                spouseQuestion1: additionalDetails?.spouse?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                spousegender: additionalDetails?.spouse?.gender
              });
            }
          }
          if ('Critical Illness Insurance'.includes(additionalDetails?.name?.split('-')[0].trim())) {
            if (additionalDetails?.member && Object.keys(additionalDetails.member).length > 0) {
              this.memberInsurance.criticalIllness = true
              this.memberInsurance.criticalIllnessCoverage = additionalDetails?.member?.coverageValue
              this.insuranceForm.patchValue({
                memberQuestion1: additionalDetails?.member?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                gender: additionalDetails?.member?.gender
              });
            }
            if (additionalDetails?.spouse && Object.keys(additionalDetails.spouse).length > 0) {
              this.spouseInsurance.criticalIllness = true
              this.spouseInsurance.criticalIllnessCoverage = additionalDetails?.spouse?.coverageValue
              this.insuranceForm.patchValue({
                spouseQuestion1: additionalDetails?.spouse?.smoker==true?'yes':'no'
              });
              this.userForm.patchValue({
                spousegender: additionalDetails?.spouse?.gender
              });
            }
          }
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

 
  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const phoneNumberPattern = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;
      const valid = phoneNumberPattern.test(control.value);
      return valid ? null : { 'phoneNumberInvalid': { value: control.value } };
    };
  }

  formatPhoneNumber(number: string): string {
    number = number.replace(/\D/g, '');
    number = number.charAt(0) != '+' ? "+" + number : "" + number;
    number = number.charAt(1) != '1' ? number.charAt(0) + "1" + number.substring(1) : "" + number;
    const countryCodeStr = number.slice(0, 2);
    const areaCodeStr = number.slice(2, 5);
    const midSectionStr = number.slice(5, 8);
    const lastSectionStr = number.slice(8);
    return `${countryCodeStr} (${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;
  }

  private isValidQuestionNumber(questionNumber: any): boolean {
    if (questionNumber == '14a') {
      questionNumber = 15
    }
    if (questionNumber == '14b') {
      questionNumber = 16
    }
    return questionNumber >= 1 && questionNumber <= 23;
  }

  // Method to check for duplicate questionNumber
  private isDuplicateQuestionNumber(questionNumber: number): boolean {
    console.log('this.addAditionalData', this.addAditionalData)
    return this.addAditionalData.some(data => data.questionNumber == questionNumber);
  }

  private isDuplicateQuestionNumber1(questionNumber: number): boolean {
    console.log('this.addAditionalData1', this.addAditionalData1)
    return this.addAditionalData1.some(data => data.questionNumber == questionNumber);
  }

  getMemberQuestionKey(questionNumber: string): string {
    const mapping: { [key: string]: string } = {
      '3': '1',
      '4': '2',
      '5': '3',
      '6': '4',
      '7': '5',
      '8': '6',
      '9': '7',
      '10': '8',
      '11': '9',
      '12': '10',
      '13': '11',
      '14a': '12',
      '14b': '13',
      '15': '14',
      '16': '15',
      '17': '16',
      '18': '17',
      '19': '18',
      '20': '19',
      '21': '20',
      '22': '21',
      '23': '22'
    };

    return mapping[questionNumber] || '';
  }

  SaveadditionalDetails() {
    this.additionalDetailsform.markAllAsTouched();
    const memberQuestions = {};

    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('memberQuestion')) {
          const questionNumber = key.replace('memberQuestion', '');
          memberQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }

    // Extract form values
    const formValue = this.additionalDetailsform.value;
    console.log({ formValue })
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    const key = this.getMemberQuestionKey(questionNumber);
    if (!key) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
      return;
    }
    if (questionNumber == '8') {
      if (memberQuestions[key] != 'no') {
        console.log(3)
        console.log(key, memberQuestions[key])
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    } else {
      if (memberQuestions[key] != 'yes') {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    }

    if (this.additionalDetailsform.invalid) {
      return;
    }

    // Validate questionNumber
    if (!this.isValidQuestionNumber(questionNumber)) {
      return;
    }

    // Check for duplicate questionNumber
    if (this.isDuplicateQuestionNumber(questionNumber)) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ duplicate: true });
      return;
    }

    console.log(JSON.stringify(this.additionalDetailsform.value, null, 2));
    let obj = {
      questionNumber,
      value,
      additionalDetails
    };

    this.addAditionalData.push(obj);
    $("#add_more").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsform.reset();
    this.additionalDetailsTable = true;
    this.additionalDetailsForm = false;
  }

  SaveadditionalDetails1() {
    this.additionalDetailsform.markAllAsTouched();
    const spouseQuestions = {};

    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('spouseQuestion')) {
          const questionNumber = key.replace('spouseQuestion', '');
          spouseQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }

    // Extract form values
    const formValue = this.additionalDetailsform.value;
    console.log({ formValue })
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    const key = this.getMemberQuestionKey(questionNumber);
    if (!key) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
      return;
    }
    if (questionNumber == '8') {
      if (spouseQuestions[key] != 'no') {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    } else {
      if (spouseQuestions[key] != 'yes') {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    }

    if (this.additionalDetailsform.invalid) {
      return;
    }

    // Validate questionNumber
    if (!this.isValidQuestionNumber(questionNumber)) {
      return;
    }

    // Check for duplicate questionNumber
    if (this.isDuplicateQuestionNumber1(questionNumber)) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ duplicate: true });
      return;
    }

    console.log(JSON.stringify(this.additionalDetailsform.value, null, 2));
    let obj = {
      questionNumber,
      value,
      additionalDetails
    };

    this.addAditionalData1.push(obj);
    $("#add_more").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsform.reset();
    this.additionalDetailsTable1 = true;
    this.additionalDetailsForm1 = false;
  }

  // Function to update additional details
  updateAdditionalDetails(): void {
    if (this.additionalDetailsform.invalid) {
      console.log('Form is invalid.');
      return;
    }

    const formValue = this.additionalDetailsform.value;
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    // Find the index of the object to update
    const index = this.addAditionalData.findIndex(item => item.questionNumber == questionNumber);

    if (index == -1) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ notFound: true });
      return;
    }

    // Update the object
    this.addAditionalData[index] = {
      questionNumber,
      value,
      additionalDetails
    };

    // Optionally reset form and hide modal
    this.additionalDetailsform.reset();
    $("#edit_question").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsTable = true;
    this.additionalDetailsFormVisible = false;
  }

  updateAdditionalDetails1(): void {
    if (this.additionalDetailsform.invalid) {
      console.log('Form is invalid.');
      return;
    }

    const formValue = this.additionalDetailsform.value;
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    const index = this.addAditionalData1.findIndex(item => item.questionNumber == questionNumber);

    if (index == -1) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ notFound: true });
      return;
    }

    this.addAditionalData1[index] = {
      questionNumber,
      value,
      additionalDetails
    };

    this.additionalDetailsform.reset();
    $("#edit_question").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsTable1 = true;
    this.additionalDetailsFormVisible1 = false;
  }

  SaveadditionalDetails12() {
    const invalid: any = [];
    const controls: any = this.insuranceForm.controls;


    for (let name in controls) {
      if (controls[name].invalid) {
        console.log(name)
      }
    }

  }

  dobOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Digits, '-' and letters: the pickers display MMM-DD-YYYY, so the month
    // has to be typeable as text (May-10-1990).
    if ((charCode >= 48 && charCode <= 57) || charCode === 45) {
      return true;
    }
    return (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122);
  }

  addMore() {
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform.reset();
    this.spouseEdit = false;
  }

  addMore1() {
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform.reset();
    this.spouseEdit = true;
  }

  closeMore() {
    this.additionalDetailsform.reset();
  }

  closeEdit() {
    this.additionalDetailsform.reset();
  }

  deleteQuestion(qNumber) {
    Swal.fire({
      title: this.lang?.Error,
      text: 'Would you like to delete this question details?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addAditionalData = this.addAditionalData.filter(data => data.questionNumber != qNumber)
        if (this.addAditionalData.length == 0) {
          this.additionalDetailsTable = false
          this.additionalDetailsForm = true;
        }
      }
    })
  }

  deleteQuestion1(qNumber) {
    Swal.fire({
      title: this.lang?.Error,
      text: 'Would you like to delete this question details?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addAditionalData1 = this.addAditionalData1.filter(data => data.questionNumber != qNumber)
        if (this.addAditionalData1.length == 0) {
          this.additionalDetailsTable1 = false
          this.additionalDetailsForm1 = true;
        }
      }
    })
  }

  alphabatesOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 65 && charCode <= 90) ||    // A-Z
      (charCode >= 97 && charCode <= 122) ||   // a-z
      (charCode >= 192 && charCode <= 255) || //À-ÖØ-öø-ÿ
      // (charCode >= 48 && charCode <= 57) ||    // 0-9
      charCode == 32 //space
      || charCode == 45 // - hypen
      || charCode == 46 //.
    )
      return true;
    else
      return false;
  }

  addQuestion() {
    console.log('this.additionalDetailsform', this.additionalDetailsform)
    this.spouseEdit ? this.SaveadditionalDetails1() : this.SaveadditionalDetails()
  }

  editQuestion() {
    console.log('this.additionalDetailsform', this.additionalDetailsform);
    this.spouseEdit ? this.updateAdditionalDetails1() : this.updateAdditionalDetails()
  }

  edit_Question(question) {
    this.spouseEdit = false;
    console.log(question)
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform = this.formBuilder.group({
      questionNumber: [question.questionNumber],
      value: [question.value],
      additionalDetails: [question.additionalDetails],
    })
    $("#edit_question").show();
  }
  edit_Question1(question) {
    this.spouseEdit = true;
    console.log(question)
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform = this.formBuilder.group({
      questionNumber: [question.questionNumber],
      value: [question.value],
      additionalDetails: [question.additionalDetails],
    })
    $("#edit_question").show();
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.isDrawing = false;
  }

  onMouseDown(e: any) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e: any) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  isConditionMetMember(i: number): boolean {
    const memberQuestionValue = this.insuranceForm.get(`memberQuestion${i}`)?.value;
    if (i === 6) {
      return memberQuestionValue === 'no';
    } else {
      return memberQuestionValue === 'yes';
    }
  }

  isConditionMetSpouse(i: number): boolean {
    const memberQuestionValue = this.insuranceForm.get(`spouseQuestion${i}`)?.value;
    if (i === 6) {
      return memberQuestionValue === 'no';
    } else {
      return memberQuestionValue === 'yes';
    }
  }

  clearSignature() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
  }

  private relativeCoords(event: any) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }
  language(event: any) {
  }

  changeFamilyMember = (val: boolean) => {
    this.isFamilyMember = val;
  }
  changeFamilySpouse = (val: boolean) => {
    this.isFamilySpouse = val;
  }

  get client() {
    return this.insuranceForm.controls;
  }

  validateFamilyMember() {
    if (this.familyForm.value.memberHasConditions == true) {
      const family = this.familyMember
      for (let key in family) {
        if (family.hasOwnProperty(key)) {
          const member = family[key];
          if (member.condition != "" && member.ageAtOnset != "") {
            this.isAtleastOneMember = false;
            return true;
          } else {
            this.isAtleastOneMember = true;
            Swal.fire({
              title: this.lang?.Error,
              text: this.lang?.Please_check_all_fields_are_entered
            })
            return;
          }
        }
      }
    }
    if (this.isSpouse && this.familyForm.value.spouseHasConditions == true) {
      const family = this.familySpouse
      for (let key in family) {
        if (family.hasOwnProperty(key)) {
          const spouse = family[key];
          if (spouse.condition != "" && spouse.ageAtOnset != "") {
            this.isAtleastOneSpouse = false;
            return true;
          } else {
            this.isAtleastOneSpouse = true;
            Swal.fire({
              title: this.lang?.Error,
              text: this.lang?.Please_check_all_fields_are_entered
            })
            return;
          }
        }
      }
    }
    return true;
  }

  handleSubmit = () => {
    console.log('handleSubmit')
    this.insuranceForm.markAllAsTouched();
    this.familyForm.markAllAsTouched();
    this.physicianForm.markAllAsTouched();
    this.physicianForm1.markAllAsTouched();

    const date = this.physicianForm.value.dateLastConsulted;
    this.physicianForm.patchValue({
      dateLastConsulted: date.toString().slice(0, 10)
    });
    const date1 = this.physicianForm.value.dateLastConsulted;
    this.physicianForm1.patchValue({
      dateLastConsulted: date1.toString().slice(0, 10)
    });

    this.addAditionalData = this.answers;
    this.addAditionalData1 = this.answers1;

    console.log('this.answers', this.answers)
    if (!this.validateFamilyMember()) {
      return;
    }

    console.log('this.memberDetails', this.memberDetails)
    console.log('this.spouseDetails', this.spouseDetails)
    console.log('this.memberInsurance', this.memberInsurance)
    console.log('this.spouseInsurance', this.spouseInsurance)

    if (this.memberDetails.pob == '') {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_member_s_place_of_birth})
      return;
    }

    if (this.memberDetails.occupation == '') {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_member_s_occupation})
      return;
    }

    if (this.isSpouse) {
      if (this.spouseDetails.pob == '') {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_spouse_s_place_of_birth })
        return;
      }

      if (this.spouseDetails.occupation == '') {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_spouse_s_occupation })
        return;
      }
    }

    const memberQuestions = {};
    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('memberQuestion')) {
          const questionNumber = key.replace('memberQuestion', '');
          memberQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }
    const spouseQuestions = {};
    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('spouseQuestion')) {
          const questionNumber = key.replace('spouseQuestion', '');
          spouseQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }
    console.log({ memberQuestions, spouseQuestions })
    console.log('this.addAditionalData', this.addAditionalData)
    console.log('this.addAditionalData1', this.addAditionalData1)
    const additionalData: any = []
    const additionalData1: any = []
    for (let i = 3; i <= 24; i++) {
      let questionNumber = i.toString()
      if (i == 14) {
        questionNumber = '14a'
      }
      if (i == 15) {
        questionNumber = '14b'
      }
      if (i > 15) {
        questionNumber = (i - 1).toString()
      }
      const key = this.getMemberQuestionKey(questionNumber);
      if (!key) {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
      const additional = this.addAditionalData.find(data => data.questionNumber.toString() == questionNumber);
      const additional1 = this.addAditionalData1.find(data => data.questionNumber.toString() == questionNumber);
      if (questionNumber == '8') {
        if (memberQuestions[key] == 'no' && additional.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'no' && additional) { additionalData.push(additional); }
        if (this.isSpouse && spouseQuestions[key] == 'no' && additional1.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'no' && additional1) { additionalData1.push(additional1); }
      } else {
        if (memberQuestions[key] == 'yes' && additional.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'yes' && additional) { additionalData.push(additional); }
        if (this.isSpouse && spouseQuestions[key] == 'yes' && additional1.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'yes' && additional1) { additionalData1.push(additional1); }
      }
    }
    console.log({ additionalData, additionalData1 })
    console.log('this.physicianForm1', this.physicianForm1.value);
    console.log('this.insuranceForm', this.insuranceForm.value);
    console.log('this.familyForm', this.familyForm.value);
    console.log('this.physicianForm', this.physicianForm.value);

    for (const control in this.insuranceForm.controls) {
      if (this.insuranceForm.controls[control].invalid) {
        console.log(`Control ${control} is invalid`, this.insuranceForm.controls[control].errors);
      }
    }
    for (const control in this.familyForm.controls) {
      if (this.familyForm.controls[control].invalid) {
        console.log(`Control ${control} is invalid`, this.familyForm.controls[control].errors);
      }
    }
    for (const control in this.physicianForm.controls) {
      if (this.physicianForm.controls[control].invalid) {
        console.log(`Control ${control} is invalid`, this.physicianForm.controls[control].errors);
      }
    }
    if (this.physicianForm.value.number.length != 17) {
      this.physicianForm.controls['number'].setErrors({ invalidPhoneNumber: true });
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return;
    }
    if (this.isSpouse) {
      for (const control in this.physicianForm1.controls) {
        if (this.physicianForm1.controls[control].invalid) {
          console.log(`Control ${control} is invalid`, this.physicianForm1.controls[control].errors);
        }
      }
      if (this.physicianForm1.value.number.length != 17) {
        this.physicianForm1.controls['number'].setErrors({ invalidPhoneNumber: true });
        Swal.fire({
          title: this.lang?.Error,
          text: this.lang?.Please_check_all_fields_are_entered
        })
        return;
      }
    }
    if (!this.insuranceForm.valid || !this.familyForm.valid || !this.physicianForm.valid) {
      console.log('insurance', this.insuranceForm.status);
      console.log('familyForm', this.familyForm.status);
      console.log('physicianForm', this.physicianForm.status);
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return;
    }
    if (this.isSpouse && !this.physicianForm1.valid) {
      console.log('physicianForm1 invalid', this.physicianForm1.status);
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return
    }

    let familyHistoryAdditionalDetails: [{
      relationship: string,
      condition: string,
      ageAtDiagnosis: string,
      ageAtDeath: string
    }] = [{
      relationship: '',
      condition: '',
      ageAtDiagnosis: '',
      ageAtDeath: ''
    }]
    familyHistoryAdditionalDetails.splice(0, 1);
    for (const [relationship, details] of Object.entries(this.familyMember)) {
      familyHistoryAdditionalDetails.push({
        relationship: relationship,
        condition: details.condition,
        ageAtDiagnosis: details.ageAtOnset,
        ageAtDeath: details.ageAtDeath
      });
    }
    let familyHistoryAdditionalDetails1: [{
      relationship: string,
      condition: string,
      ageAtDiagnosis: string,
      ageAtDeath: string
    }] = [{
      relationship: '',
      condition: '',
      ageAtDiagnosis: '',
      ageAtDeath: ''
    }]
    familyHistoryAdditionalDetails1.splice(0, 1);
    for (const [relationship, details] of Object.entries(this.familySpouse)) {
      familyHistoryAdditionalDetails1.push({
        relationship: relationship,
        condition: details.condition,
        ageAtDiagnosis: details.ageAtOnset,
        ageAtDeath: details.ageAtDeath
      });
    }

    const member = {
      height: this.insuranceForm.value.memberHeight,
      heightUnit: this.memberHeightUnit,
      weight: this.insuranceForm.value.memberWeight,
      weightUnit: this.memberweightUnit,
      isTobaccoUser: this.insuranceForm.value.memberQuestion1,
      isPilot: this.insuranceForm.value.memberQuestion2,
      doneHazardousActivity: this.insuranceForm.value.memberQuestion3,
      travelOutsideCanadaUS: this.insuranceForm.value.memberQuestion4,
      lifeInsuranceQuestion: this.insuranceForm.value.memberQuestion5,
      engagedFullTimeOccupation: this.insuranceForm.value.memberQuestion6,
      hadMalignantDiease: this.insuranceForm.value.memberQuestion7,
      hadDisorder: this.insuranceForm.value.memberQuestion8,
      hadGastrointestinalDisorder: this.insuranceForm.value.memberQuestion9,
      hadDeformity: this.insuranceForm.value.memberQuestion10,
      hasUsedDrugs: this.insuranceForm.value.memberQuestion11,
      drinksPerWeek: this.insuranceForm.value.memberQuestion12,
      changedDrinkingPattern: this.insuranceForm.value.memberQuestion13,
      hospitalizationResults: this.insuranceForm.value.memberQuestion14,
      takingPrescribedMedicine: this.insuranceForm.value.memberQuestion15,
      conditionPendingTreatment: this.insuranceForm.value.memberQuestion16,
      workAbsence: this.insuranceForm.value.memberQuestion17,
      weightVariation: this.insuranceForm.value.memberQuestion18,
      isPregnant: this.insuranceForm.value.memberQuestion19,
      hasReceivedTreatment: this.insuranceForm.value.memberQuestion20,
      claimedBenefits: this.insuranceForm.value.memberQuestion21,
      pendingCriminalOffences: this.insuranceForm.value.memberQuestion22,
      familyHistoryQuestion: this.isFamilyMember,
      familyHistoryAdditionalDetails: this.isFamilyMember ? familyHistoryAdditionalDetails : [],
      physicianInformation: this.physicianForm.value,
      // additionalDetails: this.addAditionalData
      additionalDetails: additionalData
    }
    const spouse = {
      height: this.insuranceForm.value.spouseHeight,
      heightUnit: this.spouseHeightUnit,
      weight: this.insuranceForm.value.spouseWeight,
      weightUnit: this.spouseWeightUnit,
      isTobaccoUser: this.insuranceForm.value.spouseQuestion1,
      isPilot: this.insuranceForm.value.spouseQuestion2,
      doneHazardousActivity: this.insuranceForm.value.spouseQuestion3,
      travelOutsideCanadaUS: this.insuranceForm.value.spouseQuestion4,
      lifeInsuranceQuestion: this.insuranceForm.value.spouseQuestion5,
      engagedFullTimeOccupation: this.insuranceForm.value.spouseQuestion6,
      hadMalignantDiease: this.insuranceForm.value.spouseQuestion7,
      hadDisorder: this.insuranceForm.value.spouseQuestion8,
      hadGastrointestinalDisorder: this.insuranceForm.value.spouseQuestion9,
      hadDeformity: this.insuranceForm.value.spouseQuestion10,
      hasUsedDrugs: this.insuranceForm.value.spouseQuestion11,
      drinksPerWeek: this.insuranceForm.value.spouseQuestion12,
      changedDrinkingPattern: this.insuranceForm.value.spouseQuestion13,
      hospitalizationResults: this.insuranceForm.value.spouseQuestion14,
      takingPrescribedMedicine: this.insuranceForm.value.spouseQuestion15,
      conditionPendingTreatment: this.insuranceForm.value.spouseQuestion16,
      workAbsence: this.insuranceForm.value.spouseQuestion17,
      weightVariation: this.insuranceForm.value.spouseQuestion18,
      isPregnant: this.insuranceForm.value.spouseQuestion19,
      hasReceivedTreatment: this.insuranceForm.value.spouseQuestion20,
      claimedBenefits: this.insuranceForm.value.spouseQuestion21,
      pendingCriminalOffences: this.insuranceForm.value.spouseQuestion22,
      familyHistoryQuestion: this.isFamilySpouse,
      familyHistoryAdditionalDetails: this.isFamilySpouse ? familyHistoryAdditionalDetails1 : [],
      physicianInformation: this.physicianForm1.value,
      // additionalDetails: this.addAditionalData1
      additionalDetails: additionalData1
    }

    if (this.isSpouse) {
      const obj = {
        member,
        memberInfo: { ...this.memberDetails, dob: toApiDate(this.memberDetails.dob) },
        memberInsurance: this.memberInsurance,
        spouse,
        spouseInfo: { ...this.spouseDetails, dob: toApiDate(this.spouseDetails.dob) },
        spouseInsurance: this.spouseInsurance,
        beneficiaries: this.beneficiaries,
        dateSigned: this.getCurrentDateFormatted()
      };
      console.log({ obj })
      this.postQuestions(obj);
    } else {
      const obj = {
        member,
        memberInfo: { ...this.memberDetails, dob: toApiDate(this.memberDetails.dob) },
        memberInsurance: this.memberInsurance,
        spouseInsurance: this.spouseInsurance,
        beneficiaries: this.beneficiaries,
        dateSigned: this.getCurrentDateFormatted()
      }
      console.log({ obj })
      this.postQuestions(obj);
    }
  }

  getCurrentDateFormatted(): string {
    const now = new Date(Date.now());

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(now.getDate()).padStart(2, '0'); // Ensure two digits

    return `${year}-${month}-${day}`;
  }
  postQuestions = (obj) => {
    var endPoint = `/customer/${this.customerid}/iafg/questionaire`
    this.http.post(api.url + endPoint, obj, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        const responseData = response.data;
        console.log('responseData', responseData)
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: this.lang?.Medical_Questionnaire_is_submitted_successfully_You_will_be_notified_once_processed_for_Approval })
          .then((result) => {
            if (result.value) {
              this.lifePlans?.length==0?this.addNewPlans():this.updatePlans()
            } 
          })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  public getLanguageTokens(){
    let body= {
      "project":"Member Portal",
      "url":"Questions"
    }
    this.http
    .post(api.lang + 'string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem('language')||'English'
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
        console.log(this.lang)
        this.getUpgradeLanguageTokens(this.selectedLanguage)
        this.updateQuestions();
      }
    )
  }

  public getUpgradeLanguageTokens(selectedLanguage){
    let body= {
      "project":"Member Portal",
      "url":"UpgradePlans"
    }
    this.http
    .post(api.lang + 'string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        for (let token of response.strings) {
          this.lang[token.key] = token[selectedLanguage];
        }
        console.log(this.lang)
      }
    )
  }

  updateQuestions = ()=>{
    this.questions = [
      { key: '3', label: this.lang?.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco },
      { key: '4', label: this.lang?.Have_you_flown_as_a_pilot_student_or_crew_member_in_the_last_two_years_or_do_you_have_any_intention_to_do_so },
      { key: '5', label: this.lang?.Have_you_engaged_in_or_do_you_intend_to_participate_in_scuba_diving_parachuting_or_other_hazardous_sport_or_activity },
      { key: '6', label: this.lang?.Do_you_intend_to_travel_or_reside_outside_Canada_or_the_United_States_for_more_than_a_month },
      { key: '7', label: this.lang?.Have_you_had_a_request_for_life_disability_or_critical_illness_insurance_declined_postponed_rated_or_modified_in_any_way },
      { key: '8', label: this.lang?.Are_you_now_actively_engaged_in_your_occupation_on_a_full_time_basis_If_No_please_provide_details_including_reason_why_you_are_not_working_on_a_full_time_basis },
      { key: '9', label: this.lang?.Have_you_ever_had_or_ever_been_treated_for_cancer_tumour_cyst_polyp_or_other_growth_moles_anemia_blood_disorder_or_any_form_of_malignant_disease },
      { key: '10', label: this.lang?.Have_you_ever_had_or_have_you_ever_been_treated_for_chest_pain_angina_heart_attack_high_blood_pressure_abnormal_ECG_stroke_paralysis_transient_ischemic_attack_TIA_elevated_cholesterol_or_other_disorders_of_the_heart_or_aorta_blood_vessels_or_circulatory_system_Diabetes_pancreatitis_thyroid_or_other_endocrine_disorder_Lung_or_other_respiratory_disease_or_disorder_Any_disorder_of_the_eyes_excluding_near_or_far_sightedness_ears_vocal_chords_or_larynx_including_loss_of_speech },
      { key: '11', label: this.lang?.Have_you_ever_been_treated_for_or_diagnosed_with_kidney_bladder_prostate_including_an_elevated_PSA_test_result_or_breast_disorder_including_cysts_lumps_biopsy_or_abnormal_mammogram_or_ultrasound_or_other_genitourinary_disorder_hepatitis_B_or_C_including_carrier_cirrhosis_or_other_liver_disorder_ulcerative_colitis_Crohn_s_disease_or_other_disorder_of_the_gastrointestinal_tract },
      { key: '12', label: this.lang?.Have_you_ever_had_or_have_you_ever_been_treated_for_dizziness_seizures_epilepsy_tremor_paresthesia_loss_of_balance_numbness_multiple_sclerosis_Alzheimer_s_disease_Parkinson_s_disease_amyotrophic_lateral_sclerosis_ALS_or_any_other_neurological_disorder_Stress_anxiety_depression_or_any_other_psychiatric_disorder_Disease_or_disorder_of_muscles_ligaments_tendons_bones_or_joints_including_but_not_limited_to_arthritis_lupus_in_any_form_amputation_or_deformity },
      { key: '13', label: this.lang?.Have_you_ever_used_marijuana_heroin_morphine_cocaine_LSD_barbiturates_amphetamines_or_any_other_drug_or_narcotic_except_as_prescribed_by_your_physician },
      { key: '14a', label: this.lang?.Do_you_presently_drink_more_than_12_alcoholic_beverages_per_week_If_Yes_state_number_kind_and_frequency_consumed },
      { key: '14b', label: this.lang?.Have_you_ever_changed_your_pattern_of_drinking_increased_or_decreased_received_advice_or_treatment_for_or_attended_any_rehabilitation_program_for_alcohol_or_drug_use },
      { key: '15', label: this.lang?.Have_you_any_condition_for_which_hospitalization_further_testing_investigation_or_surgery_has_been_advised_or_which_have_not_yet_been_done_or_for_which_you_are_still_awaiting_results },
      { key: '16', label: this.lang?.Are_you_taking_any_prescribed_medication_If_Yes_state_name_of_medication_and_reason_for_use },
      { key: '17', label: this.lang?.Are_you_aware_of_any_symptoms_or_complaints_regarding_your_health_for_which_you_have_not_yet_consulted_a_physician_or_received_treatment },
      { key: '18', label: this.lang?.Have_you_been_absent_from_work_for_more_than_seven_consecutive_days_within_the_past_year_due_to_sickness_or_injury },
      { key: '19', label: this.lang?.Has_there_been_a_variation_in_your_weight_in_the_past_year_If_Yes_please_provide_details_including_reason_and_number_of_pounds_kilograms_gained_or_lost },
      { key: '20', label: this.lang?.Females_only_Are_you_currently_pregnant_If_Yes_please_provide_your_estimated_due_date_and_advise_of_any_complications_with_current_or_past_pregnancies },
      { key: '21', label: this.lang?.During_the_past_10_years_have_you_consulted_a_physician_received_treatment_or_been_hospitalized_had_surgery_or_any_test_other_than_routine_checkup_or_minor_injury_for_any_disease_disorder_or_ailment_not_already_mentioned },
      { key: '22', label: this.lang?.Have_you_ever_received_or_claimed_benefits_or_a_pension_for_sickness_injury_or_impairment },
      { key: '23', label: this.lang?.Do_you_have_any_pending_criminal_offences_criminal_convictions_had_your_driver_s_license_suspended_or_within_the_past_3_years_been_convicted_of_more_than_3_traffic_violations }
    ];
  }

}


export function postalcodeValidator(control: FormControl): { [key: string]: any} | null {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null
}